/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ClerkRouteRouteImport } from './routes/clerk/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthenticatedSentryTestRouteImport } from './routes/_authenticated/sentry-test'
import { Route as AuthenticatedBalanceTransfersRouteImport } from './routes/_authenticated/balance-transfers'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignupRouteImport } from './routes/(auth)/signup'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedVendorPanelRouteRouteImport } from './routes/_authenticated/vendor-panel/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedResellerRouteRouteImport } from './routes/_authenticated/reseller/route'
import { Route as AuthenticatedCustomerRouteRouteImport } from './routes/_authenticated/customer/route'
import { Route as AuthenticatedBuyerPanelRouteRouteImport } from './routes/_authenticated/buyer-panel/route'
import { Route as AuthenticatedAuditLogsRouteRouteImport } from './routes/_authenticated/audit-logs/route'
import { Route as AuthenticatedWithdrawalsIndexRouteImport } from './routes/_authenticated/withdrawals/index'
import { Route as AuthenticatedWalkthroughsIndexRouteImport } from './routes/_authenticated/walkthroughs/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTwoFactorIndexRouteImport } from './routes/_authenticated/two-factor/index'
import { Route as AuthenticatedTokensIndexRouteImport } from './routes/_authenticated/tokens/index'
import { Route as AuthenticatedTestCallerIdsIndexRouteImport } from './routes/_authenticated/test-caller-ids/index'
import { Route as AuthenticatedTeamsIndexRouteImport } from './routes/_authenticated/teams/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedTargetsIndexRouteImport } from './routes/_authenticated/targets/index'
import { Route as AuthenticatedSupportIndexRouteImport } from './routes/_authenticated/support/index'
import { Route as AuthenticatedSmtpIndexRouteImport } from './routes/_authenticated/smtp/index'
import { Route as AuthenticatedSignupApplicationsIndexRouteImport } from './routes/_authenticated/signup-applications/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSecurityIndexRouteImport } from './routes/_authenticated/security/index'
import { Route as AuthenticatedRoutingIndexRouteImport } from './routes/_authenticated/routing/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedResellersIndexRouteImport } from './routes/_authenticated/resellers/index'
import { Route as AuthenticatedResellerIndexRouteImport } from './routes/_authenticated/reseller/index'
import { Route as AuthenticatedRecordingIndexRouteImport } from './routes/_authenticated/recording/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedPermissionsIndexRouteImport } from './routes/_authenticated/permissions/index'
import { Route as AuthenticatedPaymentsIndexRouteImport } from './routes/_authenticated/payments/index'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedMembershipsIndexRouteImport } from './routes/_authenticated/memberships/index'
import { Route as AuthenticatedMapsIndexRouteImport } from './routes/_authenticated/maps/index'
import { Route as AuthenticatedLcrIndexRouteImport } from './routes/_authenticated/lcr/index'
import { Route as AuthenticatedIpqsIndexRouteImport } from './routes/_authenticated/ipqs/index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices/index'
import { Route as AuthenticatedImpersonateIndexRouteImport } from './routes/_authenticated/impersonate/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedEmailTemplatesIndexRouteImport } from './routes/_authenticated/email-templates/index'
import { Route as AuthenticatedDidsIndexRouteImport } from './routes/_authenticated/dids/index'
import { Route as AuthenticatedDidSuspensionsIndexRouteImport } from './routes/_authenticated/did-suspensions/index'
import { Route as AuthenticatedDidProvidersIndexRouteImport } from './routes/_authenticated/did-providers/index'
import { Route as AuthenticatedDidAssignmentReportIndexRouteImport } from './routes/_authenticated/did-assignment-report/index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedCustomerIndexRouteImport } from './routes/_authenticated/customer/index'
import { Route as AuthenticatedConsolidatedReportIndexRouteImport } from './routes/_authenticated/consolidated-report/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedCdrsIndexRouteImport } from './routes/_authenticated/cdrs/index'
import { Route as AuthenticatedCampaignsIndexRouteImport } from './routes/_authenticated/campaigns/index'
import { Route as AuthenticatedCampaignTargetsIndexRouteImport } from './routes/_authenticated/campaign-targets/index'
import { Route as AuthenticatedCallVendorsIndexRouteImport } from './routes/_authenticated/call-vendors/index'
import { Route as AuthenticatedBuyerPanelIndexRouteImport } from './routes/_authenticated/buyer-panel/index'
import { Route as AuthenticatedBuyerGroupsIndexRouteImport } from './routes/_authenticated/buyer-groups/index'
import { Route as AuthenticatedBlockCallerIdsIndexRouteImport } from './routes/_authenticated/block-caller-ids/index'
import { Route as AuthenticatedBillingIndexRouteImport } from './routes/_authenticated/billing/index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedActivityIndexRouteImport } from './routes/_authenticated/activity/index'
import { Route as AuthenticatedActiveCallsIndexRouteImport } from './routes/_authenticated/active-calls/index'
import { Route as authSignupIndexRouteImport } from './routes/(auth)/signup/index'
import { Route as ClerkAuthenticatedUserManagementRouteImport } from './routes/clerk/_authenticated/user-management'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedVendorPanelDidsRouteImport } from './routes/_authenticated/vendor-panel/dids'
import { Route as AuthenticatedVendorPanelCdrsRouteImport } from './routes/_authenticated/vendor-panel/cdrs'
import { Route as AuthenticatedVendorPanelActiveCallsRouteImport } from './routes/_authenticated/vendor-panel/active-calls'
import { Route as AuthenticatedTargetsIdRouteImport } from './routes/_authenticated/targets/$id'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedResellersResellerIdRouteImport } from './routes/_authenticated/resellers/$resellerId'
import { Route as AuthenticatedResellersIdRouteImport } from './routes/_authenticated/resellers/$id'
import { Route as AuthenticatedResellerWithdrawalsRouteImport } from './routes/_authenticated/reseller/withdrawals'
import { Route as AuthenticatedResellerWhitelabelRouteImport } from './routes/_authenticated/reseller/whitelabel'
import { Route as AuthenticatedResellerSuspendedNumbersRouteImport } from './routes/_authenticated/reseller/suspended-numbers'
import { Route as AuthenticatedResellerSmtpRouteImport } from './routes/_authenticated/reseller/smtp'
import { Route as AuthenticatedResellerReportsRouteImport } from './routes/_authenticated/reseller/reports'
import { Route as AuthenticatedResellerPaymentsRouteImport } from './routes/_authenticated/reseller/payments'
import { Route as AuthenticatedResellerNumbersRouteImport } from './routes/_authenticated/reseller/numbers'
import { Route as AuthenticatedResellerNotificationsRouteImport } from './routes/_authenticated/reseller/notifications'
import { Route as AuthenticatedResellerInvoicesRouteImport } from './routes/_authenticated/reseller/invoices'
import { Route as AuthenticatedResellerImpersonateRouteImport } from './routes/_authenticated/reseller/impersonate'
import { Route as AuthenticatedResellerDidTransfersRouteImport } from './routes/_authenticated/reseller/did-transfers'
import { Route as AuthenticatedResellerCustomersRouteImport } from './routes/_authenticated/reseller/customers'
import { Route as AuthenticatedResellerConsolidatedReportRouteImport } from './routes/_authenticated/reseller/consolidated-report'
import { Route as AuthenticatedResellerCdrsRouteImport } from './routes/_authenticated/reseller/cdrs'
import { Route as AuthenticatedResellerBlockCallerIdsRouteImport } from './routes/_authenticated/reseller/block-caller-ids'
import { Route as AuthenticatedResellerBillingRouteImport } from './routes/_authenticated/reseller/billing'
import { Route as AuthenticatedResellerBalanceTransfersRouteImport } from './routes/_authenticated/reseller/balance-transfers'
import { Route as AuthenticatedResellerActivityLogsRouteImport } from './routes/_authenticated/reseller/activity-logs'
import { Route as AuthenticatedFinancePaymentsRouteImport } from './routes/_authenticated/finance/payments'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedDidsIdRouteImport } from './routes/_authenticated/dids/$id'
import { Route as AuthenticatedCustomersIdRouteImport } from './routes/_authenticated/customers/$id'
import { Route as AuthenticatedCustomerTargetsRouteImport } from './routes/_authenticated/customer/targets'
import { Route as AuthenticatedCustomerSuspendedNumbersRouteImport } from './routes/_authenticated/customer/suspended-numbers'
import { Route as AuthenticatedCustomerSettingsRouteImport } from './routes/_authenticated/customer/settings'
import { Route as AuthenticatedCustomerRoutingDidsRouteImport } from './routes/_authenticated/customer/routing-dids'
import { Route as AuthenticatedCustomerReportsRouteImport } from './routes/_authenticated/customer/reports'
import { Route as AuthenticatedCustomerPaymentsRouteImport } from './routes/_authenticated/customer/payments'
import { Route as AuthenticatedCustomerNumbersRouteImport } from './routes/_authenticated/customer/numbers'
import { Route as AuthenticatedCustomerNotificationsRouteImport } from './routes/_authenticated/customer/notifications'
import { Route as AuthenticatedCustomerInvoicesRouteImport } from './routes/_authenticated/customer/invoices'
import { Route as AuthenticatedCustomerGenerateReportsRouteImport } from './routes/_authenticated/customer/generate-reports'
import { Route as AuthenticatedCustomerDailyReportsRouteImport } from './routes/_authenticated/customer/daily-reports'
import { Route as AuthenticatedCustomerConsolidatedReportRouteImport } from './routes/_authenticated/customer/consolidated-report'
import { Route as AuthenticatedCustomerCdrsRouteImport } from './routes/_authenticated/customer/cdrs'
import { Route as AuthenticatedCustomerCampaignTargetsRouteImport } from './routes/_authenticated/customer/campaign-targets'
import { Route as AuthenticatedCustomerCallVendorsRouteImport } from './routes/_authenticated/customer/call-vendors'
import { Route as AuthenticatedCustomerCallBlocksRouteImport } from './routes/_authenticated/customer/call-blocks'
import { Route as AuthenticatedCustomerBuyerGroupsRouteImport } from './routes/_authenticated/customer/buyer-groups'
import { Route as AuthenticatedCustomerBillingRouteImport } from './routes/_authenticated/customer/billing'
import { Route as AuthenticatedCustomerApiTokensRouteImport } from './routes/_authenticated/customer/api-tokens'
import { Route as AuthenticatedCustomerActivityLogsRouteImport } from './routes/_authenticated/customer/activity-logs'
import { Route as AuthenticatedCampaignTargetsIdRouteImport } from './routes/_authenticated/campaign-targets/$id'
import { Route as AuthenticatedBuyerPanelTargetsRouteImport } from './routes/_authenticated/buyer-panel/targets'
import { Route as AuthenticatedBuyerPanelCdrsRouteImport } from './routes/_authenticated/buyer-panel/cdrs'
import { Route as AuthenticatedBuyerPanelActiveCallsRouteImport } from './routes/_authenticated/buyer-panel/active-calls'
import { Route as authSignupResellerRouteImport } from './routes/(auth)/signup/reseller'
import { Route as authSignInCallbackRouteImport } from './routes/(auth)/sign-in/callback'
import { Route as auth2faResetRouteImport } from './routes/(auth)/2fa/reset'
import { Route as AuthenticatedCustomerCampaignsRouteRouteImport } from './routes/_authenticated/customer/campaigns/route'
import { Route as AuthenticatedSettingsUsersIndexRouteImport } from './routes/_authenticated/settings/users/index'
import { Route as AuthenticatedSettingsTestCallerIdsIndexRouteImport } from './routes/_authenticated/settings/test-caller-ids/index'
import { Route as AuthenticatedSettingsSmtpIndexRouteImport } from './routes/_authenticated/settings/smtp/index'
import { Route as AuthenticatedSettingsSignupApplicationsIndexRouteImport } from './routes/_authenticated/settings/signup-applications/index'
import { Route as AuthenticatedSettingsSecurityIndexRouteImport } from './routes/_authenticated/settings/security/index'
import { Route as AuthenticatedSettingsRecordingIndexRouteImport } from './routes/_authenticated/settings/recording/index'
import { Route as AuthenticatedSettingsPaymentsIndexRouteImport } from './routes/_authenticated/settings/payments/index'
import { Route as AuthenticatedSettingsEmailTemplatesIndexRouteImport } from './routes/_authenticated/settings/email-templates/index'
import { Route as AuthenticatedFreeswitchTrunksIndexRouteImport } from './routes/_authenticated/freeswitch/trunks/index'
import { Route as AuthenticatedFreeswitchServersIndexRouteImport } from './routes/_authenticated/freeswitch/servers/index'
import { Route as AuthenticatedFreeswitchProfilesIndexRouteImport } from './routes/_authenticated/freeswitch/profiles/index'
import { Route as AuthenticatedFreeswitchGatewaysIndexRouteImport } from './routes/_authenticated/freeswitch/gateways/index'
import { Route as AuthenticatedFreeswitchApplyIndexRouteImport } from './routes/_authenticated/freeswitch/apply/index'
import { Route as AuthenticatedDidsImportIndexRouteImport } from './routes/_authenticated/dids/import/index'
import { Route as AuthenticatedCustomerCampaignsIndexRouteImport } from './routes/_authenticated/customer/campaigns/index'
import { Route as AuthenticatedCdrsUnauthorizedIndexRouteImport } from './routes/_authenticated/cdrs/unauthorized/index'
import { Route as AuthenticatedCampaignsIdIndexRouteImport } from './routes/_authenticated/campaigns/$id/index'
import { Route as AuthenticatedResellerFinancePaymentsRouteImport } from './routes/_authenticated/reseller/finance/payments'
import { Route as AuthenticatedCustomerFinancePaymentsRouteImport } from './routes/_authenticated/customer/finance/payments'
import { Route as AuthenticatedCampaignsIdAnalyticsRouteImport } from './routes/_authenticated/campaigns/$id/analytics'
import { Route as AuthenticatedCustomerCampaignsIdAnalyticsRouteImport } from './routes/_authenticated/customer/campaigns/$id/analytics'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkRouteRoute = ClerkRouteRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSentryTestRoute = AuthenticatedSentryTestRouteImport.update({
  id: '/sentry-test',
  path: '/sentry-test',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBalanceTransfersRoute =
  AuthenticatedBalanceTransfersRouteImport.update({
    id: '/balance-transfers',
    path: '/balance-transfers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignupRoute = authSignupRouteImport.update({
  id: '/(auth)/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const AuthenticatedVendorPanelRouteRoute =
  AuthenticatedVendorPanelRouteRouteImport.update({
    id: '/vendor-panel',
    path: '/vendor-panel',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResellerRouteRoute =
  AuthenticatedResellerRouteRouteImport.update({
    id: '/reseller',
    path: '/reseller',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomerRouteRoute =
  AuthenticatedCustomerRouteRouteImport.update({
    id: '/customer',
    path: '/customer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBuyerPanelRouteRoute =
  AuthenticatedBuyerPanelRouteRouteImport.update({
    id: '/buyer-panel',
    path: '/buyer-panel',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAuditLogsRouteRoute =
  AuthenticatedAuditLogsRouteRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWithdrawalsIndexRoute =
  AuthenticatedWithdrawalsIndexRouteImport.update({
    id: '/withdrawals/',
    path: '/withdrawals/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWalkthroughsIndexRoute =
  AuthenticatedWalkthroughsIndexRouteImport.update({
    id: '/walkthroughs/',
    path: '/walkthroughs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTwoFactorIndexRoute =
  AuthenticatedTwoFactorIndexRouteImport.update({
    id: '/two-factor/',
    path: '/two-factor/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTokensIndexRoute =
  AuthenticatedTokensIndexRouteImport.update({
    id: '/tokens/',
    path: '/tokens/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTestCallerIdsIndexRoute =
  AuthenticatedTestCallerIdsIndexRouteImport.update({
    id: '/test-caller-ids/',
    path: '/test-caller-ids/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTeamsIndexRoute = AuthenticatedTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTargetsIndexRoute =
  AuthenticatedTargetsIndexRouteImport.update({
    id: '/targets/',
    path: '/targets/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSupportIndexRoute =
  AuthenticatedSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSmtpIndexRoute = AuthenticatedSmtpIndexRouteImport.update({
  id: '/smtp/',
  path: '/smtp/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSignupApplicationsIndexRoute =
  AuthenticatedSignupApplicationsIndexRouteImport.update({
    id: '/signup-applications/',
    path: '/signup-applications/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSecurityIndexRoute =
  AuthenticatedSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRoutingIndexRoute =
  AuthenticatedRoutingIndexRouteImport.update({
    id: '/routing/',
    path: '/routing/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedResellersIndexRoute =
  AuthenticatedResellersIndexRouteImport.update({
    id: '/resellers/',
    path: '/resellers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResellerIndexRoute =
  AuthenticatedResellerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedRecordingIndexRoute =
  AuthenticatedRecordingIndexRouteImport.update({
    id: '/recording/',
    path: '/recording/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPermissionsIndexRoute =
  AuthenticatedPermissionsIndexRouteImport.update({
    id: '/permissions/',
    path: '/permissions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPaymentsIndexRoute =
  AuthenticatedPaymentsIndexRouteImport.update({
    id: '/payments/',
    path: '/payments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMembershipsIndexRoute =
  AuthenticatedMembershipsIndexRouteImport.update({
    id: '/memberships/',
    path: '/memberships/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMapsIndexRoute = AuthenticatedMapsIndexRouteImport.update({
  id: '/maps/',
  path: '/maps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLcrIndexRoute = AuthenticatedLcrIndexRouteImport.update({
  id: '/lcr/',
  path: '/lcr/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedIpqsIndexRoute = AuthenticatedIpqsIndexRouteImport.update({
  id: '/ipqs/',
  path: '/ipqs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedImpersonateIndexRoute =
  AuthenticatedImpersonateIndexRouteImport.update({
    id: '/impersonate/',
    path: '/impersonate/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEmailTemplatesIndexRoute =
  AuthenticatedEmailTemplatesIndexRouteImport.update({
    id: '/email-templates/',
    path: '/email-templates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDidsIndexRoute = AuthenticatedDidsIndexRouteImport.update({
  id: '/dids/',
  path: '/dids/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDidSuspensionsIndexRoute =
  AuthenticatedDidSuspensionsIndexRouteImport.update({
    id: '/did-suspensions/',
    path: '/did-suspensions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDidProvidersIndexRoute =
  AuthenticatedDidProvidersIndexRouteImport.update({
    id: '/did-providers/',
    path: '/did-providers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDidAssignmentReportIndexRoute =
  AuthenticatedDidAssignmentReportIndexRouteImport.update({
    id: '/did-assignment-report/',
    path: '/did-assignment-report/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomerIndexRoute =
  AuthenticatedCustomerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedConsolidatedReportIndexRoute =
  AuthenticatedConsolidatedReportIndexRouteImport.update({
    id: '/consolidated-report/',
    path: '/consolidated-report/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCdrsIndexRoute = AuthenticatedCdrsIndexRouteImport.update({
  id: '/cdrs/',
  path: '/cdrs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCampaignsIndexRoute =
  AuthenticatedCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCampaignTargetsIndexRoute =
  AuthenticatedCampaignTargetsIndexRouteImport.update({
    id: '/campaign-targets/',
    path: '/campaign-targets/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCallVendorsIndexRoute =
  AuthenticatedCallVendorsIndexRouteImport.update({
    id: '/call-vendors/',
    path: '/call-vendors/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBuyerPanelIndexRoute =
  AuthenticatedBuyerPanelIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBuyerPanelRouteRoute,
  } as any)
const AuthenticatedBuyerGroupsIndexRoute =
  AuthenticatedBuyerGroupsIndexRouteImport.update({
    id: '/buyer-groups/',
    path: '/buyer-groups/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBlockCallerIdsIndexRoute =
  AuthenticatedBlockCallerIdsIndexRouteImport.update({
    id: '/block-caller-ids/',
    path: '/block-caller-ids/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingIndexRoute =
  AuthenticatedBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedActivityIndexRoute =
  AuthenticatedActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedActiveCallsIndexRoute =
  AuthenticatedActiveCallsIndexRouteImport.update({
    id: '/active-calls/',
    path: '/active-calls/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const authSignupIndexRoute = authSignupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authSignupRoute,
} as any)
const ClerkAuthenticatedUserManagementRoute =
  ClerkAuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => ClerkAuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedVendorPanelDidsRoute =
  AuthenticatedVendorPanelDidsRouteImport.update({
    id: '/dids',
    path: '/dids',
    getParentRoute: () => AuthenticatedVendorPanelRouteRoute,
  } as any)
const AuthenticatedVendorPanelCdrsRoute =
  AuthenticatedVendorPanelCdrsRouteImport.update({
    id: '/cdrs',
    path: '/cdrs',
    getParentRoute: () => AuthenticatedVendorPanelRouteRoute,
  } as any)
const AuthenticatedVendorPanelActiveCallsRoute =
  AuthenticatedVendorPanelActiveCallsRouteImport.update({
    id: '/active-calls',
    path: '/active-calls',
    getParentRoute: () => AuthenticatedVendorPanelRouteRoute,
  } as any)
const AuthenticatedTargetsIdRoute = AuthenticatedTargetsIdRouteImport.update({
  id: '/targets/$id',
  path: '/targets/$id',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedResellersResellerIdRoute =
  AuthenticatedResellersResellerIdRouteImport.update({
    id: '/resellers/$resellerId',
    path: '/resellers/$resellerId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResellersIdRoute =
  AuthenticatedResellersIdRouteImport.update({
    id: '/resellers/$id',
    path: '/resellers/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResellerWithdrawalsRoute =
  AuthenticatedResellerWithdrawalsRouteImport.update({
    id: '/withdrawals',
    path: '/withdrawals',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerWhitelabelRoute =
  AuthenticatedResellerWhitelabelRouteImport.update({
    id: '/whitelabel',
    path: '/whitelabel',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerSuspendedNumbersRoute =
  AuthenticatedResellerSuspendedNumbersRouteImport.update({
    id: '/suspended-numbers',
    path: '/suspended-numbers',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerSmtpRoute =
  AuthenticatedResellerSmtpRouteImport.update({
    id: '/smtp',
    path: '/smtp',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerReportsRoute =
  AuthenticatedResellerReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerPaymentsRoute =
  AuthenticatedResellerPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerNumbersRoute =
  AuthenticatedResellerNumbersRouteImport.update({
    id: '/numbers',
    path: '/numbers',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerNotificationsRoute =
  AuthenticatedResellerNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerInvoicesRoute =
  AuthenticatedResellerInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerImpersonateRoute =
  AuthenticatedResellerImpersonateRouteImport.update({
    id: '/impersonate',
    path: '/impersonate',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerDidTransfersRoute =
  AuthenticatedResellerDidTransfersRouteImport.update({
    id: '/did-transfers',
    path: '/did-transfers',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerCustomersRoute =
  AuthenticatedResellerCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerConsolidatedReportRoute =
  AuthenticatedResellerConsolidatedReportRouteImport.update({
    id: '/consolidated-report',
    path: '/consolidated-report',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerCdrsRoute =
  AuthenticatedResellerCdrsRouteImport.update({
    id: '/cdrs',
    path: '/cdrs',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerBlockCallerIdsRoute =
  AuthenticatedResellerBlockCallerIdsRouteImport.update({
    id: '/block-caller-ids',
    path: '/block-caller-ids',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerBillingRoute =
  AuthenticatedResellerBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerBalanceTransfersRoute =
  AuthenticatedResellerBalanceTransfersRouteImport.update({
    id: '/balance-transfers',
    path: '/balance-transfers',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedResellerActivityLogsRoute =
  AuthenticatedResellerActivityLogsRouteImport.update({
    id: '/activity-logs',
    path: '/activity-logs',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedFinancePaymentsRoute =
  AuthenticatedFinancePaymentsRouteImport.update({
    id: '/finance/payments',
    path: '/finance/payments',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDidsIdRoute = AuthenticatedDidsIdRouteImport.update({
  id: '/dids/$id',
  path: '/dids/$id',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCustomersIdRoute =
  AuthenticatedCustomersIdRouteImport.update({
    id: '/customers/$id',
    path: '/customers/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomerTargetsRoute =
  AuthenticatedCustomerTargetsRouteImport.update({
    id: '/targets',
    path: '/targets',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerSuspendedNumbersRoute =
  AuthenticatedCustomerSuspendedNumbersRouteImport.update({
    id: '/suspended-numbers',
    path: '/suspended-numbers',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerSettingsRoute =
  AuthenticatedCustomerSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerRoutingDidsRoute =
  AuthenticatedCustomerRoutingDidsRouteImport.update({
    id: '/routing-dids',
    path: '/routing-dids',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerReportsRoute =
  AuthenticatedCustomerReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerPaymentsRoute =
  AuthenticatedCustomerPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerNumbersRoute =
  AuthenticatedCustomerNumbersRouteImport.update({
    id: '/numbers',
    path: '/numbers',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerNotificationsRoute =
  AuthenticatedCustomerNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerInvoicesRoute =
  AuthenticatedCustomerInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerGenerateReportsRoute =
  AuthenticatedCustomerGenerateReportsRouteImport.update({
    id: '/generate-reports',
    path: '/generate-reports',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerDailyReportsRoute =
  AuthenticatedCustomerDailyReportsRouteImport.update({
    id: '/daily-reports',
    path: '/daily-reports',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerConsolidatedReportRoute =
  AuthenticatedCustomerConsolidatedReportRouteImport.update({
    id: '/consolidated-report',
    path: '/consolidated-report',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerCdrsRoute =
  AuthenticatedCustomerCdrsRouteImport.update({
    id: '/cdrs',
    path: '/cdrs',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerCampaignTargetsRoute =
  AuthenticatedCustomerCampaignTargetsRouteImport.update({
    id: '/campaign-targets',
    path: '/campaign-targets',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerCallVendorsRoute =
  AuthenticatedCustomerCallVendorsRouteImport.update({
    id: '/call-vendors',
    path: '/call-vendors',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerCallBlocksRoute =
  AuthenticatedCustomerCallBlocksRouteImport.update({
    id: '/call-blocks',
    path: '/call-blocks',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerBuyerGroupsRoute =
  AuthenticatedCustomerBuyerGroupsRouteImport.update({
    id: '/buyer-groups',
    path: '/buyer-groups',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerBillingRoute =
  AuthenticatedCustomerBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerApiTokensRoute =
  AuthenticatedCustomerApiTokensRouteImport.update({
    id: '/api-tokens',
    path: '/api-tokens',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCustomerActivityLogsRoute =
  AuthenticatedCustomerActivityLogsRouteImport.update({
    id: '/activity-logs',
    path: '/activity-logs',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCampaignTargetsIdRoute =
  AuthenticatedCampaignTargetsIdRouteImport.update({
    id: '/campaign-targets/$id',
    path: '/campaign-targets/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBuyerPanelTargetsRoute =
  AuthenticatedBuyerPanelTargetsRouteImport.update({
    id: '/targets',
    path: '/targets',
    getParentRoute: () => AuthenticatedBuyerPanelRouteRoute,
  } as any)
const AuthenticatedBuyerPanelCdrsRoute =
  AuthenticatedBuyerPanelCdrsRouteImport.update({
    id: '/cdrs',
    path: '/cdrs',
    getParentRoute: () => AuthenticatedBuyerPanelRouteRoute,
  } as any)
const AuthenticatedBuyerPanelActiveCallsRoute =
  AuthenticatedBuyerPanelActiveCallsRouteImport.update({
    id: '/active-calls',
    path: '/active-calls',
    getParentRoute: () => AuthenticatedBuyerPanelRouteRoute,
  } as any)
const authSignupResellerRoute = authSignupResellerRouteImport.update({
  id: '/reseller',
  path: '/reseller',
  getParentRoute: () => authSignupRoute,
} as any)
const authSignInCallbackRoute = authSignInCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => authSignInRoute,
} as any)
const auth2faResetRoute = auth2faResetRouteImport.update({
  id: '/(auth)/2fa/reset',
  path: '/2fa/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCustomerCampaignsRouteRoute =
  AuthenticatedCustomerCampaignsRouteRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedSettingsUsersIndexRoute =
  AuthenticatedSettingsUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsTestCallerIdsIndexRoute =
  AuthenticatedSettingsTestCallerIdsIndexRouteImport.update({
    id: '/test-caller-ids/',
    path: '/test-caller-ids/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsSmtpIndexRoute =
  AuthenticatedSettingsSmtpIndexRouteImport.update({
    id: '/smtp/',
    path: '/smtp/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsSignupApplicationsIndexRoute =
  AuthenticatedSettingsSignupApplicationsIndexRouteImport.update({
    id: '/signup-applications/',
    path: '/signup-applications/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsSecurityIndexRoute =
  AuthenticatedSettingsSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsRecordingIndexRoute =
  AuthenticatedSettingsRecordingIndexRouteImport.update({
    id: '/recording/',
    path: '/recording/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsPaymentsIndexRoute =
  AuthenticatedSettingsPaymentsIndexRouteImport.update({
    id: '/payments/',
    path: '/payments/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsEmailTemplatesIndexRoute =
  AuthenticatedSettingsEmailTemplatesIndexRouteImport.update({
    id: '/email-templates/',
    path: '/email-templates/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedFreeswitchTrunksIndexRoute =
  AuthenticatedFreeswitchTrunksIndexRouteImport.update({
    id: '/freeswitch/trunks/',
    path: '/freeswitch/trunks/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFreeswitchServersIndexRoute =
  AuthenticatedFreeswitchServersIndexRouteImport.update({
    id: '/freeswitch/servers/',
    path: '/freeswitch/servers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFreeswitchProfilesIndexRoute =
  AuthenticatedFreeswitchProfilesIndexRouteImport.update({
    id: '/freeswitch/profiles/',
    path: '/freeswitch/profiles/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFreeswitchGatewaysIndexRoute =
  AuthenticatedFreeswitchGatewaysIndexRouteImport.update({
    id: '/freeswitch/gateways/',
    path: '/freeswitch/gateways/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFreeswitchApplyIndexRoute =
  AuthenticatedFreeswitchApplyIndexRouteImport.update({
    id: '/freeswitch/apply/',
    path: '/freeswitch/apply/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDidsImportIndexRoute =
  AuthenticatedDidsImportIndexRouteImport.update({
    id: '/dids/import/',
    path: '/dids/import/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomerCampaignsIndexRoute =
  AuthenticatedCustomerCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomerCampaignsRouteRoute,
  } as any)
const AuthenticatedCdrsUnauthorizedIndexRoute =
  AuthenticatedCdrsUnauthorizedIndexRouteImport.update({
    id: '/cdrs/unauthorized/',
    path: '/cdrs/unauthorized/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCampaignsIdIndexRoute =
  AuthenticatedCampaignsIdIndexRouteImport.update({
    id: '/campaigns/$id/',
    path: '/campaigns/$id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedResellerFinancePaymentsRoute =
  AuthenticatedResellerFinancePaymentsRouteImport.update({
    id: '/finance/payments',
    path: '/finance/payments',
    getParentRoute: () => AuthenticatedResellerRouteRoute,
  } as any)
const AuthenticatedCustomerFinancePaymentsRoute =
  AuthenticatedCustomerFinancePaymentsRouteImport.update({
    id: '/finance/payments',
    path: '/finance/payments',
    getParentRoute: () => AuthenticatedCustomerRouteRoute,
  } as any)
const AuthenticatedCampaignsIdAnalyticsRoute =
  AuthenticatedCampaignsIdAnalyticsRouteImport.update({
    id: '/campaigns/$id/analytics',
    path: '/campaigns/$id/analytics',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomerCampaignsIdAnalyticsRoute =
  AuthenticatedCustomerCampaignsIdAnalyticsRouteImport.update({
    id: '/$id/analytics',
    path: '/$id/analytics',
    getParentRoute: () => AuthenticatedCustomerCampaignsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/clerk': typeof ClerkauthRouteRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/audit-logs': typeof AuthenticatedAuditLogsRouteRoute
  '/buyer-panel': typeof AuthenticatedBuyerPanelRouteRouteWithChildren
  '/customer': typeof AuthenticatedCustomerRouteRouteWithChildren
  '/reseller': typeof AuthenticatedResellerRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/vendor-panel': typeof AuthenticatedVendorPanelRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRouteWithChildren
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/signup': typeof authSignupRouteWithChildren
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/balance-transfers': typeof AuthenticatedBalanceTransfersRoute
  '/sentry-test': typeof AuthenticatedSentryTestRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/customer/campaigns': typeof AuthenticatedCustomerCampaignsRouteRouteWithChildren
  '/2fa/reset': typeof auth2faResetRoute
  '/sign-in/callback': typeof authSignInCallbackRoute
  '/signup/reseller': typeof authSignupResellerRoute
  '/buyer-panel/active-calls': typeof AuthenticatedBuyerPanelActiveCallsRoute
  '/buyer-panel/cdrs': typeof AuthenticatedBuyerPanelCdrsRoute
  '/buyer-panel/targets': typeof AuthenticatedBuyerPanelTargetsRoute
  '/campaign-targets/$id': typeof AuthenticatedCampaignTargetsIdRoute
  '/customer/activity-logs': typeof AuthenticatedCustomerActivityLogsRoute
  '/customer/api-tokens': typeof AuthenticatedCustomerApiTokensRoute
  '/customer/billing': typeof AuthenticatedCustomerBillingRoute
  '/customer/buyer-groups': typeof AuthenticatedCustomerBuyerGroupsRoute
  '/customer/call-blocks': typeof AuthenticatedCustomerCallBlocksRoute
  '/customer/call-vendors': typeof AuthenticatedCustomerCallVendorsRoute
  '/customer/campaign-targets': typeof AuthenticatedCustomerCampaignTargetsRoute
  '/customer/cdrs': typeof AuthenticatedCustomerCdrsRoute
  '/customer/consolidated-report': typeof AuthenticatedCustomerConsolidatedReportRoute
  '/customer/daily-reports': typeof AuthenticatedCustomerDailyReportsRoute
  '/customer/generate-reports': typeof AuthenticatedCustomerGenerateReportsRoute
  '/customer/invoices': typeof AuthenticatedCustomerInvoicesRoute
  '/customer/notifications': typeof AuthenticatedCustomerNotificationsRoute
  '/customer/numbers': typeof AuthenticatedCustomerNumbersRoute
  '/customer/payments': typeof AuthenticatedCustomerPaymentsRoute
  '/customer/reports': typeof AuthenticatedCustomerReportsRoute
  '/customer/routing-dids': typeof AuthenticatedCustomerRoutingDidsRoute
  '/customer/settings': typeof AuthenticatedCustomerSettingsRoute
  '/customer/suspended-numbers': typeof AuthenticatedCustomerSuspendedNumbersRoute
  '/customer/targets': typeof AuthenticatedCustomerTargetsRoute
  '/customers/$id': typeof AuthenticatedCustomersIdRoute
  '/dids/$id': typeof AuthenticatedDidsIdRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/finance/payments': typeof AuthenticatedFinancePaymentsRoute
  '/reseller/activity-logs': typeof AuthenticatedResellerActivityLogsRoute
  '/reseller/balance-transfers': typeof AuthenticatedResellerBalanceTransfersRoute
  '/reseller/billing': typeof AuthenticatedResellerBillingRoute
  '/reseller/block-caller-ids': typeof AuthenticatedResellerBlockCallerIdsRoute
  '/reseller/cdrs': typeof AuthenticatedResellerCdrsRoute
  '/reseller/consolidated-report': typeof AuthenticatedResellerConsolidatedReportRoute
  '/reseller/customers': typeof AuthenticatedResellerCustomersRoute
  '/reseller/did-transfers': typeof AuthenticatedResellerDidTransfersRoute
  '/reseller/impersonate': typeof AuthenticatedResellerImpersonateRoute
  '/reseller/invoices': typeof AuthenticatedResellerInvoicesRoute
  '/reseller/notifications': typeof AuthenticatedResellerNotificationsRoute
  '/reseller/numbers': typeof AuthenticatedResellerNumbersRoute
  '/reseller/payments': typeof AuthenticatedResellerPaymentsRoute
  '/reseller/reports': typeof AuthenticatedResellerReportsRoute
  '/reseller/smtp': typeof AuthenticatedResellerSmtpRoute
  '/reseller/suspended-numbers': typeof AuthenticatedResellerSuspendedNumbersRoute
  '/reseller/whitelabel': typeof AuthenticatedResellerWhitelabelRoute
  '/reseller/withdrawals': typeof AuthenticatedResellerWithdrawalsRoute
  '/resellers/$id': typeof AuthenticatedResellersIdRoute
  '/resellers/$resellerId': typeof AuthenticatedResellersResellerIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/targets/$id': typeof AuthenticatedTargetsIdRoute
  '/vendor-panel/active-calls': typeof AuthenticatedVendorPanelActiveCallsRoute
  '/vendor-panel/cdrs': typeof AuthenticatedVendorPanelCdrsRoute
  '/vendor-panel/dids': typeof AuthenticatedVendorPanelDidsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/signup/': typeof authSignupIndexRoute
  '/active-calls/': typeof AuthenticatedActiveCallsIndexRoute
  '/activity/': typeof AuthenticatedActivityIndexRoute
  '/apps/': typeof AuthenticatedAppsIndexRoute
  '/billing/': typeof AuthenticatedBillingIndexRoute
  '/block-caller-ids/': typeof AuthenticatedBlockCallerIdsIndexRoute
  '/buyer-groups/': typeof AuthenticatedBuyerGroupsIndexRoute
  '/buyer-panel/': typeof AuthenticatedBuyerPanelIndexRoute
  '/call-vendors/': typeof AuthenticatedCallVendorsIndexRoute
  '/campaign-targets/': typeof AuthenticatedCampaignTargetsIndexRoute
  '/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/cdrs/': typeof AuthenticatedCdrsIndexRoute
  '/chats/': typeof AuthenticatedChatsIndexRoute
  '/consolidated-report/': typeof AuthenticatedConsolidatedReportIndexRoute
  '/customer/': typeof AuthenticatedCustomerIndexRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/did-assignment-report/': typeof AuthenticatedDidAssignmentReportIndexRoute
  '/did-providers/': typeof AuthenticatedDidProvidersIndexRoute
  '/did-suspensions/': typeof AuthenticatedDidSuspensionsIndexRoute
  '/dids/': typeof AuthenticatedDidsIndexRoute
  '/email-templates/': typeof AuthenticatedEmailTemplatesIndexRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/impersonate/': typeof AuthenticatedImpersonateIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/ipqs/': typeof AuthenticatedIpqsIndexRoute
  '/lcr/': typeof AuthenticatedLcrIndexRoute
  '/maps/': typeof AuthenticatedMapsIndexRoute
  '/memberships/': typeof AuthenticatedMembershipsIndexRoute
  '/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/payments/': typeof AuthenticatedPaymentsIndexRoute
  '/permissions/': typeof AuthenticatedPermissionsIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/recording/': typeof AuthenticatedRecordingIndexRoute
  '/reseller/': typeof AuthenticatedResellerIndexRoute
  '/resellers/': typeof AuthenticatedResellersIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/routing/': typeof AuthenticatedRoutingIndexRoute
  '/security/': typeof AuthenticatedSecurityIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/signup-applications/': typeof AuthenticatedSignupApplicationsIndexRoute
  '/smtp/': typeof AuthenticatedSmtpIndexRoute
  '/support/': typeof AuthenticatedSupportIndexRoute
  '/targets/': typeof AuthenticatedTargetsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/teams/': typeof AuthenticatedTeamsIndexRoute
  '/test-caller-ids/': typeof AuthenticatedTestCallerIdsIndexRoute
  '/tokens/': typeof AuthenticatedTokensIndexRoute
  '/two-factor/': typeof AuthenticatedTwoFactorIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/walkthroughs/': typeof AuthenticatedWalkthroughsIndexRoute
  '/withdrawals/': typeof AuthenticatedWithdrawalsIndexRoute
  '/campaigns/$id/analytics': typeof AuthenticatedCampaignsIdAnalyticsRoute
  '/customer/finance/payments': typeof AuthenticatedCustomerFinancePaymentsRoute
  '/reseller/finance/payments': typeof AuthenticatedResellerFinancePaymentsRoute
  '/campaigns/$id/': typeof AuthenticatedCampaignsIdIndexRoute
  '/cdrs/unauthorized/': typeof AuthenticatedCdrsUnauthorizedIndexRoute
  '/customer/campaigns/': typeof AuthenticatedCustomerCampaignsIndexRoute
  '/dids/import/': typeof AuthenticatedDidsImportIndexRoute
  '/freeswitch/apply/': typeof AuthenticatedFreeswitchApplyIndexRoute
  '/freeswitch/gateways/': typeof AuthenticatedFreeswitchGatewaysIndexRoute
  '/freeswitch/profiles/': typeof AuthenticatedFreeswitchProfilesIndexRoute
  '/freeswitch/servers/': typeof AuthenticatedFreeswitchServersIndexRoute
  '/freeswitch/trunks/': typeof AuthenticatedFreeswitchTrunksIndexRoute
  '/settings/email-templates/': typeof AuthenticatedSettingsEmailTemplatesIndexRoute
  '/settings/payments/': typeof AuthenticatedSettingsPaymentsIndexRoute
  '/settings/recording/': typeof AuthenticatedSettingsRecordingIndexRoute
  '/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute
  '/settings/signup-applications/': typeof AuthenticatedSettingsSignupApplicationsIndexRoute
  '/settings/smtp/': typeof AuthenticatedSettingsSmtpIndexRoute
  '/settings/test-caller-ids/': typeof AuthenticatedSettingsTestCallerIdsIndexRoute
  '/settings/users/': typeof AuthenticatedSettingsUsersIndexRoute
  '/customer/campaigns/$id/analytics': typeof AuthenticatedCustomerCampaignsIdAnalyticsRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkauthRouteRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/audit-logs': typeof AuthenticatedAuditLogsRouteRoute
  '/vendor-panel': typeof AuthenticatedVendorPanelRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRouteWithChildren
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/balance-transfers': typeof AuthenticatedBalanceTransfersRoute
  '/sentry-test': typeof AuthenticatedSentryTestRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/': typeof AuthenticatedIndexRoute
  '/2fa/reset': typeof auth2faResetRoute
  '/sign-in/callback': typeof authSignInCallbackRoute
  '/signup/reseller': typeof authSignupResellerRoute
  '/buyer-panel/active-calls': typeof AuthenticatedBuyerPanelActiveCallsRoute
  '/buyer-panel/cdrs': typeof AuthenticatedBuyerPanelCdrsRoute
  '/buyer-panel/targets': typeof AuthenticatedBuyerPanelTargetsRoute
  '/campaign-targets/$id': typeof AuthenticatedCampaignTargetsIdRoute
  '/customer/activity-logs': typeof AuthenticatedCustomerActivityLogsRoute
  '/customer/api-tokens': typeof AuthenticatedCustomerApiTokensRoute
  '/customer/billing': typeof AuthenticatedCustomerBillingRoute
  '/customer/buyer-groups': typeof AuthenticatedCustomerBuyerGroupsRoute
  '/customer/call-blocks': typeof AuthenticatedCustomerCallBlocksRoute
  '/customer/call-vendors': typeof AuthenticatedCustomerCallVendorsRoute
  '/customer/campaign-targets': typeof AuthenticatedCustomerCampaignTargetsRoute
  '/customer/cdrs': typeof AuthenticatedCustomerCdrsRoute
  '/customer/consolidated-report': typeof AuthenticatedCustomerConsolidatedReportRoute
  '/customer/daily-reports': typeof AuthenticatedCustomerDailyReportsRoute
  '/customer/generate-reports': typeof AuthenticatedCustomerGenerateReportsRoute
  '/customer/invoices': typeof AuthenticatedCustomerInvoicesRoute
  '/customer/notifications': typeof AuthenticatedCustomerNotificationsRoute
  '/customer/numbers': typeof AuthenticatedCustomerNumbersRoute
  '/customer/payments': typeof AuthenticatedCustomerPaymentsRoute
  '/customer/reports': typeof AuthenticatedCustomerReportsRoute
  '/customer/routing-dids': typeof AuthenticatedCustomerRoutingDidsRoute
  '/customer/settings': typeof AuthenticatedCustomerSettingsRoute
  '/customer/suspended-numbers': typeof AuthenticatedCustomerSuspendedNumbersRoute
  '/customer/targets': typeof AuthenticatedCustomerTargetsRoute
  '/customers/$id': typeof AuthenticatedCustomersIdRoute
  '/dids/$id': typeof AuthenticatedDidsIdRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/finance/payments': typeof AuthenticatedFinancePaymentsRoute
  '/reseller/activity-logs': typeof AuthenticatedResellerActivityLogsRoute
  '/reseller/balance-transfers': typeof AuthenticatedResellerBalanceTransfersRoute
  '/reseller/billing': typeof AuthenticatedResellerBillingRoute
  '/reseller/block-caller-ids': typeof AuthenticatedResellerBlockCallerIdsRoute
  '/reseller/cdrs': typeof AuthenticatedResellerCdrsRoute
  '/reseller/consolidated-report': typeof AuthenticatedResellerConsolidatedReportRoute
  '/reseller/customers': typeof AuthenticatedResellerCustomersRoute
  '/reseller/did-transfers': typeof AuthenticatedResellerDidTransfersRoute
  '/reseller/impersonate': typeof AuthenticatedResellerImpersonateRoute
  '/reseller/invoices': typeof AuthenticatedResellerInvoicesRoute
  '/reseller/notifications': typeof AuthenticatedResellerNotificationsRoute
  '/reseller/numbers': typeof AuthenticatedResellerNumbersRoute
  '/reseller/payments': typeof AuthenticatedResellerPaymentsRoute
  '/reseller/reports': typeof AuthenticatedResellerReportsRoute
  '/reseller/smtp': typeof AuthenticatedResellerSmtpRoute
  '/reseller/suspended-numbers': typeof AuthenticatedResellerSuspendedNumbersRoute
  '/reseller/whitelabel': typeof AuthenticatedResellerWhitelabelRoute
  '/reseller/withdrawals': typeof AuthenticatedResellerWithdrawalsRoute
  '/resellers/$id': typeof AuthenticatedResellersIdRoute
  '/resellers/$resellerId': typeof AuthenticatedResellersResellerIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/targets/$id': typeof AuthenticatedTargetsIdRoute
  '/vendor-panel/active-calls': typeof AuthenticatedVendorPanelActiveCallsRoute
  '/vendor-panel/cdrs': typeof AuthenticatedVendorPanelCdrsRoute
  '/vendor-panel/dids': typeof AuthenticatedVendorPanelDidsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/signup': typeof authSignupIndexRoute
  '/active-calls': typeof AuthenticatedActiveCallsIndexRoute
  '/activity': typeof AuthenticatedActivityIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/billing': typeof AuthenticatedBillingIndexRoute
  '/block-caller-ids': typeof AuthenticatedBlockCallerIdsIndexRoute
  '/buyer-groups': typeof AuthenticatedBuyerGroupsIndexRoute
  '/buyer-panel': typeof AuthenticatedBuyerPanelIndexRoute
  '/call-vendors': typeof AuthenticatedCallVendorsIndexRoute
  '/campaign-targets': typeof AuthenticatedCampaignTargetsIndexRoute
  '/campaigns': typeof AuthenticatedCampaignsIndexRoute
  '/cdrs': typeof AuthenticatedCdrsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/consolidated-report': typeof AuthenticatedConsolidatedReportIndexRoute
  '/customer': typeof AuthenticatedCustomerIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/did-assignment-report': typeof AuthenticatedDidAssignmentReportIndexRoute
  '/did-providers': typeof AuthenticatedDidProvidersIndexRoute
  '/did-suspensions': typeof AuthenticatedDidSuspensionsIndexRoute
  '/dids': typeof AuthenticatedDidsIndexRoute
  '/email-templates': typeof AuthenticatedEmailTemplatesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/impersonate': typeof AuthenticatedImpersonateIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/ipqs': typeof AuthenticatedIpqsIndexRoute
  '/lcr': typeof AuthenticatedLcrIndexRoute
  '/maps': typeof AuthenticatedMapsIndexRoute
  '/memberships': typeof AuthenticatedMembershipsIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/payments': typeof AuthenticatedPaymentsIndexRoute
  '/permissions': typeof AuthenticatedPermissionsIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/recording': typeof AuthenticatedRecordingIndexRoute
  '/reseller': typeof AuthenticatedResellerIndexRoute
  '/resellers': typeof AuthenticatedResellersIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/routing': typeof AuthenticatedRoutingIndexRoute
  '/security': typeof AuthenticatedSecurityIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/signup-applications': typeof AuthenticatedSignupApplicationsIndexRoute
  '/smtp': typeof AuthenticatedSmtpIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
  '/targets': typeof AuthenticatedTargetsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/teams': typeof AuthenticatedTeamsIndexRoute
  '/test-caller-ids': typeof AuthenticatedTestCallerIdsIndexRoute
  '/tokens': typeof AuthenticatedTokensIndexRoute
  '/two-factor': typeof AuthenticatedTwoFactorIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/walkthroughs': typeof AuthenticatedWalkthroughsIndexRoute
  '/withdrawals': typeof AuthenticatedWithdrawalsIndexRoute
  '/campaigns/$id/analytics': typeof AuthenticatedCampaignsIdAnalyticsRoute
  '/customer/finance/payments': typeof AuthenticatedCustomerFinancePaymentsRoute
  '/reseller/finance/payments': typeof AuthenticatedResellerFinancePaymentsRoute
  '/campaigns/$id': typeof AuthenticatedCampaignsIdIndexRoute
  '/cdrs/unauthorized': typeof AuthenticatedCdrsUnauthorizedIndexRoute
  '/customer/campaigns': typeof AuthenticatedCustomerCampaignsIndexRoute
  '/dids/import': typeof AuthenticatedDidsImportIndexRoute
  '/freeswitch/apply': typeof AuthenticatedFreeswitchApplyIndexRoute
  '/freeswitch/gateways': typeof AuthenticatedFreeswitchGatewaysIndexRoute
  '/freeswitch/profiles': typeof AuthenticatedFreeswitchProfilesIndexRoute
  '/freeswitch/servers': typeof AuthenticatedFreeswitchServersIndexRoute
  '/freeswitch/trunks': typeof AuthenticatedFreeswitchTrunksIndexRoute
  '/settings/email-templates': typeof AuthenticatedSettingsEmailTemplatesIndexRoute
  '/settings/payments': typeof AuthenticatedSettingsPaymentsIndexRoute
  '/settings/recording': typeof AuthenticatedSettingsRecordingIndexRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityIndexRoute
  '/settings/signup-applications': typeof AuthenticatedSettingsSignupApplicationsIndexRoute
  '/settings/smtp': typeof AuthenticatedSettingsSmtpIndexRoute
  '/settings/test-caller-ids': typeof AuthenticatedSettingsTestCallerIdsIndexRoute
  '/settings/users': typeof AuthenticatedSettingsUsersIndexRoute
  '/customer/campaigns/$id/analytics': typeof AuthenticatedCustomerCampaignsIdAnalyticsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/clerk': typeof ClerkRouteRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/audit-logs': typeof AuthenticatedAuditLogsRouteRoute
  '/_authenticated/buyer-panel': typeof AuthenticatedBuyerPanelRouteRouteWithChildren
  '/_authenticated/customer': typeof AuthenticatedCustomerRouteRouteWithChildren
  '/_authenticated/reseller': typeof AuthenticatedResellerRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/vendor-panel': typeof AuthenticatedVendorPanelRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRouteWithChildren
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(auth)/signup': typeof authSignupRouteWithChildren
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/balance-transfers': typeof AuthenticatedBalanceTransfersRoute
  '/_authenticated/sentry-test': typeof AuthenticatedSentryTestRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/customer/campaigns': typeof AuthenticatedCustomerCampaignsRouteRouteWithChildren
  '/(auth)/2fa/reset': typeof auth2faResetRoute
  '/(auth)/sign-in/callback': typeof authSignInCallbackRoute
  '/(auth)/signup/reseller': typeof authSignupResellerRoute
  '/_authenticated/buyer-panel/active-calls': typeof AuthenticatedBuyerPanelActiveCallsRoute
  '/_authenticated/buyer-panel/cdrs': typeof AuthenticatedBuyerPanelCdrsRoute
  '/_authenticated/buyer-panel/targets': typeof AuthenticatedBuyerPanelTargetsRoute
  '/_authenticated/campaign-targets/$id': typeof AuthenticatedCampaignTargetsIdRoute
  '/_authenticated/customer/activity-logs': typeof AuthenticatedCustomerActivityLogsRoute
  '/_authenticated/customer/api-tokens': typeof AuthenticatedCustomerApiTokensRoute
  '/_authenticated/customer/billing': typeof AuthenticatedCustomerBillingRoute
  '/_authenticated/customer/buyer-groups': typeof AuthenticatedCustomerBuyerGroupsRoute
  '/_authenticated/customer/call-blocks': typeof AuthenticatedCustomerCallBlocksRoute
  '/_authenticated/customer/call-vendors': typeof AuthenticatedCustomerCallVendorsRoute
  '/_authenticated/customer/campaign-targets': typeof AuthenticatedCustomerCampaignTargetsRoute
  '/_authenticated/customer/cdrs': typeof AuthenticatedCustomerCdrsRoute
  '/_authenticated/customer/consolidated-report': typeof AuthenticatedCustomerConsolidatedReportRoute
  '/_authenticated/customer/daily-reports': typeof AuthenticatedCustomerDailyReportsRoute
  '/_authenticated/customer/generate-reports': typeof AuthenticatedCustomerGenerateReportsRoute
  '/_authenticated/customer/invoices': typeof AuthenticatedCustomerInvoicesRoute
  '/_authenticated/customer/notifications': typeof AuthenticatedCustomerNotificationsRoute
  '/_authenticated/customer/numbers': typeof AuthenticatedCustomerNumbersRoute
  '/_authenticated/customer/payments': typeof AuthenticatedCustomerPaymentsRoute
  '/_authenticated/customer/reports': typeof AuthenticatedCustomerReportsRoute
  '/_authenticated/customer/routing-dids': typeof AuthenticatedCustomerRoutingDidsRoute
  '/_authenticated/customer/settings': typeof AuthenticatedCustomerSettingsRoute
  '/_authenticated/customer/suspended-numbers': typeof AuthenticatedCustomerSuspendedNumbersRoute
  '/_authenticated/customer/targets': typeof AuthenticatedCustomerTargetsRoute
  '/_authenticated/customers/$id': typeof AuthenticatedCustomersIdRoute
  '/_authenticated/dids/$id': typeof AuthenticatedDidsIdRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/finance/payments': typeof AuthenticatedFinancePaymentsRoute
  '/_authenticated/reseller/activity-logs': typeof AuthenticatedResellerActivityLogsRoute
  '/_authenticated/reseller/balance-transfers': typeof AuthenticatedResellerBalanceTransfersRoute
  '/_authenticated/reseller/billing': typeof AuthenticatedResellerBillingRoute
  '/_authenticated/reseller/block-caller-ids': typeof AuthenticatedResellerBlockCallerIdsRoute
  '/_authenticated/reseller/cdrs': typeof AuthenticatedResellerCdrsRoute
  '/_authenticated/reseller/consolidated-report': typeof AuthenticatedResellerConsolidatedReportRoute
  '/_authenticated/reseller/customers': typeof AuthenticatedResellerCustomersRoute
  '/_authenticated/reseller/did-transfers': typeof AuthenticatedResellerDidTransfersRoute
  '/_authenticated/reseller/impersonate': typeof AuthenticatedResellerImpersonateRoute
  '/_authenticated/reseller/invoices': typeof AuthenticatedResellerInvoicesRoute
  '/_authenticated/reseller/notifications': typeof AuthenticatedResellerNotificationsRoute
  '/_authenticated/reseller/numbers': typeof AuthenticatedResellerNumbersRoute
  '/_authenticated/reseller/payments': typeof AuthenticatedResellerPaymentsRoute
  '/_authenticated/reseller/reports': typeof AuthenticatedResellerReportsRoute
  '/_authenticated/reseller/smtp': typeof AuthenticatedResellerSmtpRoute
  '/_authenticated/reseller/suspended-numbers': typeof AuthenticatedResellerSuspendedNumbersRoute
  '/_authenticated/reseller/whitelabel': typeof AuthenticatedResellerWhitelabelRoute
  '/_authenticated/reseller/withdrawals': typeof AuthenticatedResellerWithdrawalsRoute
  '/_authenticated/resellers/$id': typeof AuthenticatedResellersIdRoute
  '/_authenticated/resellers/$resellerId': typeof AuthenticatedResellersResellerIdRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/targets/$id': typeof AuthenticatedTargetsIdRoute
  '/_authenticated/vendor-panel/active-calls': typeof AuthenticatedVendorPanelActiveCallsRoute
  '/_authenticated/vendor-panel/cdrs': typeof AuthenticatedVendorPanelCdrsRoute
  '/_authenticated/vendor-panel/dids': typeof AuthenticatedVendorPanelDidsRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/_authenticated/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/(auth)/signup/': typeof authSignupIndexRoute
  '/_authenticated/active-calls/': typeof AuthenticatedActiveCallsIndexRoute
  '/_authenticated/activity/': typeof AuthenticatedActivityIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/billing/': typeof AuthenticatedBillingIndexRoute
  '/_authenticated/block-caller-ids/': typeof AuthenticatedBlockCallerIdsIndexRoute
  '/_authenticated/buyer-groups/': typeof AuthenticatedBuyerGroupsIndexRoute
  '/_authenticated/buyer-panel/': typeof AuthenticatedBuyerPanelIndexRoute
  '/_authenticated/call-vendors/': typeof AuthenticatedCallVendorsIndexRoute
  '/_authenticated/campaign-targets/': typeof AuthenticatedCampaignTargetsIndexRoute
  '/_authenticated/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/_authenticated/cdrs/': typeof AuthenticatedCdrsIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/consolidated-report/': typeof AuthenticatedConsolidatedReportIndexRoute
  '/_authenticated/customer/': typeof AuthenticatedCustomerIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/did-assignment-report/': typeof AuthenticatedDidAssignmentReportIndexRoute
  '/_authenticated/did-providers/': typeof AuthenticatedDidProvidersIndexRoute
  '/_authenticated/did-suspensions/': typeof AuthenticatedDidSuspensionsIndexRoute
  '/_authenticated/dids/': typeof AuthenticatedDidsIndexRoute
  '/_authenticated/email-templates/': typeof AuthenticatedEmailTemplatesIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/impersonate/': typeof AuthenticatedImpersonateIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/ipqs/': typeof AuthenticatedIpqsIndexRoute
  '/_authenticated/lcr/': typeof AuthenticatedLcrIndexRoute
  '/_authenticated/maps/': typeof AuthenticatedMapsIndexRoute
  '/_authenticated/memberships/': typeof AuthenticatedMembershipsIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/payments/': typeof AuthenticatedPaymentsIndexRoute
  '/_authenticated/permissions/': typeof AuthenticatedPermissionsIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/recording/': typeof AuthenticatedRecordingIndexRoute
  '/_authenticated/reseller/': typeof AuthenticatedResellerIndexRoute
  '/_authenticated/resellers/': typeof AuthenticatedResellersIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/routing/': typeof AuthenticatedRoutingIndexRoute
  '/_authenticated/security/': typeof AuthenticatedSecurityIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/signup-applications/': typeof AuthenticatedSignupApplicationsIndexRoute
  '/_authenticated/smtp/': typeof AuthenticatedSmtpIndexRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexRoute
  '/_authenticated/targets/': typeof AuthenticatedTargetsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/teams/': typeof AuthenticatedTeamsIndexRoute
  '/_authenticated/test-caller-ids/': typeof AuthenticatedTestCallerIdsIndexRoute
  '/_authenticated/tokens/': typeof AuthenticatedTokensIndexRoute
  '/_authenticated/two-factor/': typeof AuthenticatedTwoFactorIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/walkthroughs/': typeof AuthenticatedWalkthroughsIndexRoute
  '/_authenticated/withdrawals/': typeof AuthenticatedWithdrawalsIndexRoute
  '/_authenticated/campaigns/$id/analytics': typeof AuthenticatedCampaignsIdAnalyticsRoute
  '/_authenticated/customer/finance/payments': typeof AuthenticatedCustomerFinancePaymentsRoute
  '/_authenticated/reseller/finance/payments': typeof AuthenticatedResellerFinancePaymentsRoute
  '/_authenticated/campaigns/$id/': typeof AuthenticatedCampaignsIdIndexRoute
  '/_authenticated/cdrs/unauthorized/': typeof AuthenticatedCdrsUnauthorizedIndexRoute
  '/_authenticated/customer/campaigns/': typeof AuthenticatedCustomerCampaignsIndexRoute
  '/_authenticated/dids/import/': typeof AuthenticatedDidsImportIndexRoute
  '/_authenticated/freeswitch/apply/': typeof AuthenticatedFreeswitchApplyIndexRoute
  '/_authenticated/freeswitch/gateways/': typeof AuthenticatedFreeswitchGatewaysIndexRoute
  '/_authenticated/freeswitch/profiles/': typeof AuthenticatedFreeswitchProfilesIndexRoute
  '/_authenticated/freeswitch/servers/': typeof AuthenticatedFreeswitchServersIndexRoute
  '/_authenticated/freeswitch/trunks/': typeof AuthenticatedFreeswitchTrunksIndexRoute
  '/_authenticated/settings/email-templates/': typeof AuthenticatedSettingsEmailTemplatesIndexRoute
  '/_authenticated/settings/payments/': typeof AuthenticatedSettingsPaymentsIndexRoute
  '/_authenticated/settings/recording/': typeof AuthenticatedSettingsRecordingIndexRoute
  '/_authenticated/settings/security/': typeof AuthenticatedSettingsSecurityIndexRoute
  '/_authenticated/settings/signup-applications/': typeof AuthenticatedSettingsSignupApplicationsIndexRoute
  '/_authenticated/settings/smtp/': typeof AuthenticatedSettingsSmtpIndexRoute
  '/_authenticated/settings/test-caller-ids/': typeof AuthenticatedSettingsTestCallerIdsIndexRoute
  '/_authenticated/settings/users/': typeof AuthenticatedSettingsUsersIndexRoute
  '/_authenticated/customer/campaigns/$id/analytics': typeof AuthenticatedCustomerCampaignsIdAnalyticsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/clerk'
    | '/reset-password'
    | '/audit-logs'
    | '/buyer-panel'
    | '/customer'
    | '/reseller'
    | '/settings'
    | '/vendor-panel'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/signup'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/balance-transfers'
    | '/sentry-test'
    | '/auth/reset-password'
    | '/customer/campaigns'
    | '/2fa/reset'
    | '/sign-in/callback'
    | '/signup/reseller'
    | '/buyer-panel/active-calls'
    | '/buyer-panel/cdrs'
    | '/buyer-panel/targets'
    | '/campaign-targets/$id'
    | '/customer/activity-logs'
    | '/customer/api-tokens'
    | '/customer/billing'
    | '/customer/buyer-groups'
    | '/customer/call-blocks'
    | '/customer/call-vendors'
    | '/customer/campaign-targets'
    | '/customer/cdrs'
    | '/customer/consolidated-report'
    | '/customer/daily-reports'
    | '/customer/generate-reports'
    | '/customer/invoices'
    | '/customer/notifications'
    | '/customer/numbers'
    | '/customer/payments'
    | '/customer/reports'
    | '/customer/routing-dids'
    | '/customer/settings'
    | '/customer/suspended-numbers'
    | '/customer/targets'
    | '/customers/$id'
    | '/dids/$id'
    | '/errors/$error'
    | '/finance/payments'
    | '/reseller/activity-logs'
    | '/reseller/balance-transfers'
    | '/reseller/billing'
    | '/reseller/block-caller-ids'
    | '/reseller/cdrs'
    | '/reseller/consolidated-report'
    | '/reseller/customers'
    | '/reseller/did-transfers'
    | '/reseller/impersonate'
    | '/reseller/invoices'
    | '/reseller/notifications'
    | '/reseller/numbers'
    | '/reseller/payments'
    | '/reseller/reports'
    | '/reseller/smtp'
    | '/reseller/suspended-numbers'
    | '/reseller/whitelabel'
    | '/reseller/withdrawals'
    | '/resellers/$id'
    | '/resellers/$resellerId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/targets/$id'
    | '/vendor-panel/active-calls'
    | '/vendor-panel/cdrs'
    | '/vendor-panel/dids'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/signup/'
    | '/active-calls/'
    | '/activity/'
    | '/apps/'
    | '/billing/'
    | '/block-caller-ids/'
    | '/buyer-groups/'
    | '/buyer-panel/'
    | '/call-vendors/'
    | '/campaign-targets/'
    | '/campaigns/'
    | '/cdrs/'
    | '/chats/'
    | '/consolidated-report/'
    | '/customer/'
    | '/customers/'
    | '/did-assignment-report/'
    | '/did-providers/'
    | '/did-suspensions/'
    | '/dids/'
    | '/email-templates/'
    | '/help-center/'
    | '/impersonate/'
    | '/invoices/'
    | '/ipqs/'
    | '/lcr/'
    | '/maps/'
    | '/memberships/'
    | '/notifications/'
    | '/organizations/'
    | '/payments/'
    | '/permissions/'
    | '/profile/'
    | '/recording/'
    | '/reseller/'
    | '/resellers/'
    | '/roles/'
    | '/routing/'
    | '/security/'
    | '/settings/'
    | '/signup-applications/'
    | '/smtp/'
    | '/support/'
    | '/targets/'
    | '/tasks/'
    | '/teams/'
    | '/test-caller-ids/'
    | '/tokens/'
    | '/two-factor/'
    | '/users/'
    | '/walkthroughs/'
    | '/withdrawals/'
    | '/campaigns/$id/analytics'
    | '/customer/finance/payments'
    | '/reseller/finance/payments'
    | '/campaigns/$id/'
    | '/cdrs/unauthorized/'
    | '/customer/campaigns/'
    | '/dids/import/'
    | '/freeswitch/apply/'
    | '/freeswitch/gateways/'
    | '/freeswitch/profiles/'
    | '/freeswitch/servers/'
    | '/freeswitch/trunks/'
    | '/settings/email-templates/'
    | '/settings/payments/'
    | '/settings/recording/'
    | '/settings/security/'
    | '/settings/signup-applications/'
    | '/settings/smtp/'
    | '/settings/test-caller-ids/'
    | '/settings/users/'
    | '/customer/campaigns/$id/analytics'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/reset-password'
    | '/audit-logs'
    | '/vendor-panel'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/balance-transfers'
    | '/sentry-test'
    | '/auth/reset-password'
    | '/'
    | '/2fa/reset'
    | '/sign-in/callback'
    | '/signup/reseller'
    | '/buyer-panel/active-calls'
    | '/buyer-panel/cdrs'
    | '/buyer-panel/targets'
    | '/campaign-targets/$id'
    | '/customer/activity-logs'
    | '/customer/api-tokens'
    | '/customer/billing'
    | '/customer/buyer-groups'
    | '/customer/call-blocks'
    | '/customer/call-vendors'
    | '/customer/campaign-targets'
    | '/customer/cdrs'
    | '/customer/consolidated-report'
    | '/customer/daily-reports'
    | '/customer/generate-reports'
    | '/customer/invoices'
    | '/customer/notifications'
    | '/customer/numbers'
    | '/customer/payments'
    | '/customer/reports'
    | '/customer/routing-dids'
    | '/customer/settings'
    | '/customer/suspended-numbers'
    | '/customer/targets'
    | '/customers/$id'
    | '/dids/$id'
    | '/errors/$error'
    | '/finance/payments'
    | '/reseller/activity-logs'
    | '/reseller/balance-transfers'
    | '/reseller/billing'
    | '/reseller/block-caller-ids'
    | '/reseller/cdrs'
    | '/reseller/consolidated-report'
    | '/reseller/customers'
    | '/reseller/did-transfers'
    | '/reseller/impersonate'
    | '/reseller/invoices'
    | '/reseller/notifications'
    | '/reseller/numbers'
    | '/reseller/payments'
    | '/reseller/reports'
    | '/reseller/smtp'
    | '/reseller/suspended-numbers'
    | '/reseller/whitelabel'
    | '/reseller/withdrawals'
    | '/resellers/$id'
    | '/resellers/$resellerId'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/targets/$id'
    | '/vendor-panel/active-calls'
    | '/vendor-panel/cdrs'
    | '/vendor-panel/dids'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/signup'
    | '/active-calls'
    | '/activity'
    | '/apps'
    | '/billing'
    | '/block-caller-ids'
    | '/buyer-groups'
    | '/buyer-panel'
    | '/call-vendors'
    | '/campaign-targets'
    | '/campaigns'
    | '/cdrs'
    | '/chats'
    | '/consolidated-report'
    | '/customer'
    | '/customers'
    | '/did-assignment-report'
    | '/did-providers'
    | '/did-suspensions'
    | '/dids'
    | '/email-templates'
    | '/help-center'
    | '/impersonate'
    | '/invoices'
    | '/ipqs'
    | '/lcr'
    | '/maps'
    | '/memberships'
    | '/notifications'
    | '/organizations'
    | '/payments'
    | '/permissions'
    | '/profile'
    | '/recording'
    | '/reseller'
    | '/resellers'
    | '/roles'
    | '/routing'
    | '/security'
    | '/settings'
    | '/signup-applications'
    | '/smtp'
    | '/support'
    | '/targets'
    | '/tasks'
    | '/teams'
    | '/test-caller-ids'
    | '/tokens'
    | '/two-factor'
    | '/users'
    | '/walkthroughs'
    | '/withdrawals'
    | '/campaigns/$id/analytics'
    | '/customer/finance/payments'
    | '/reseller/finance/payments'
    | '/campaigns/$id'
    | '/cdrs/unauthorized'
    | '/customer/campaigns'
    | '/dids/import'
    | '/freeswitch/apply'
    | '/freeswitch/gateways'
    | '/freeswitch/profiles'
    | '/freeswitch/servers'
    | '/freeswitch/trunks'
    | '/settings/email-templates'
    | '/settings/payments'
    | '/settings/recording'
    | '/settings/security'
    | '/settings/signup-applications'
    | '/settings/smtp'
    | '/settings/test-caller-ids'
    | '/settings/users'
    | '/customer/campaigns/$id/analytics'
  id:
    | '__root__'
    | '/_authenticated'
    | '/clerk'
    | '/reset-password'
    | '/_authenticated/audit-logs'
    | '/_authenticated/buyer-panel'
    | '/_authenticated/customer'
    | '/_authenticated/reseller'
    | '/_authenticated/settings'
    | '/_authenticated/vendor-panel'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(auth)/signup'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/balance-transfers'
    | '/_authenticated/sentry-test'
    | '/auth/reset-password'
    | '/_authenticated/'
    | '/_authenticated/customer/campaigns'
    | '/(auth)/2fa/reset'
    | '/(auth)/sign-in/callback'
    | '/(auth)/signup/reseller'
    | '/_authenticated/buyer-panel/active-calls'
    | '/_authenticated/buyer-panel/cdrs'
    | '/_authenticated/buyer-panel/targets'
    | '/_authenticated/campaign-targets/$id'
    | '/_authenticated/customer/activity-logs'
    | '/_authenticated/customer/api-tokens'
    | '/_authenticated/customer/billing'
    | '/_authenticated/customer/buyer-groups'
    | '/_authenticated/customer/call-blocks'
    | '/_authenticated/customer/call-vendors'
    | '/_authenticated/customer/campaign-targets'
    | '/_authenticated/customer/cdrs'
    | '/_authenticated/customer/consolidated-report'
    | '/_authenticated/customer/daily-reports'
    | '/_authenticated/customer/generate-reports'
    | '/_authenticated/customer/invoices'
    | '/_authenticated/customer/notifications'
    | '/_authenticated/customer/numbers'
    | '/_authenticated/customer/payments'
    | '/_authenticated/customer/reports'
    | '/_authenticated/customer/routing-dids'
    | '/_authenticated/customer/settings'
    | '/_authenticated/customer/suspended-numbers'
    | '/_authenticated/customer/targets'
    | '/_authenticated/customers/$id'
    | '/_authenticated/dids/$id'
    | '/_authenticated/errors/$error'
    | '/_authenticated/finance/payments'
    | '/_authenticated/reseller/activity-logs'
    | '/_authenticated/reseller/balance-transfers'
    | '/_authenticated/reseller/billing'
    | '/_authenticated/reseller/block-caller-ids'
    | '/_authenticated/reseller/cdrs'
    | '/_authenticated/reseller/consolidated-report'
    | '/_authenticated/reseller/customers'
    | '/_authenticated/reseller/did-transfers'
    | '/_authenticated/reseller/impersonate'
    | '/_authenticated/reseller/invoices'
    | '/_authenticated/reseller/notifications'
    | '/_authenticated/reseller/numbers'
    | '/_authenticated/reseller/payments'
    | '/_authenticated/reseller/reports'
    | '/_authenticated/reseller/smtp'
    | '/_authenticated/reseller/suspended-numbers'
    | '/_authenticated/reseller/whitelabel'
    | '/_authenticated/reseller/withdrawals'
    | '/_authenticated/resellers/$id'
    | '/_authenticated/resellers/$resellerId'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/targets/$id'
    | '/_authenticated/vendor-panel/active-calls'
    | '/_authenticated/vendor-panel/cdrs'
    | '/_authenticated/vendor-panel/dids'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/clerk/_authenticated/user-management'
    | '/(auth)/signup/'
    | '/_authenticated/active-calls/'
    | '/_authenticated/activity/'
    | '/_authenticated/apps/'
    | '/_authenticated/billing/'
    | '/_authenticated/block-caller-ids/'
    | '/_authenticated/buyer-groups/'
    | '/_authenticated/buyer-panel/'
    | '/_authenticated/call-vendors/'
    | '/_authenticated/campaign-targets/'
    | '/_authenticated/campaigns/'
    | '/_authenticated/cdrs/'
    | '/_authenticated/chats/'
    | '/_authenticated/consolidated-report/'
    | '/_authenticated/customer/'
    | '/_authenticated/customers/'
    | '/_authenticated/did-assignment-report/'
    | '/_authenticated/did-providers/'
    | '/_authenticated/did-suspensions/'
    | '/_authenticated/dids/'
    | '/_authenticated/email-templates/'
    | '/_authenticated/help-center/'
    | '/_authenticated/impersonate/'
    | '/_authenticated/invoices/'
    | '/_authenticated/ipqs/'
    | '/_authenticated/lcr/'
    | '/_authenticated/maps/'
    | '/_authenticated/memberships/'
    | '/_authenticated/notifications/'
    | '/_authenticated/organizations/'
    | '/_authenticated/payments/'
    | '/_authenticated/permissions/'
    | '/_authenticated/profile/'
    | '/_authenticated/recording/'
    | '/_authenticated/reseller/'
    | '/_authenticated/resellers/'
    | '/_authenticated/roles/'
    | '/_authenticated/routing/'
    | '/_authenticated/security/'
    | '/_authenticated/settings/'
    | '/_authenticated/signup-applications/'
    | '/_authenticated/smtp/'
    | '/_authenticated/support/'
    | '/_authenticated/targets/'
    | '/_authenticated/tasks/'
    | '/_authenticated/teams/'
    | '/_authenticated/test-caller-ids/'
    | '/_authenticated/tokens/'
    | '/_authenticated/two-factor/'
    | '/_authenticated/users/'
    | '/_authenticated/walkthroughs/'
    | '/_authenticated/withdrawals/'
    | '/_authenticated/campaigns/$id/analytics'
    | '/_authenticated/customer/finance/payments'
    | '/_authenticated/reseller/finance/payments'
    | '/_authenticated/campaigns/$id/'
    | '/_authenticated/cdrs/unauthorized/'
    | '/_authenticated/customer/campaigns/'
    | '/_authenticated/dids/import/'
    | '/_authenticated/freeswitch/apply/'
    | '/_authenticated/freeswitch/gateways/'
    | '/_authenticated/freeswitch/profiles/'
    | '/_authenticated/freeswitch/servers/'
    | '/_authenticated/freeswitch/trunks/'
    | '/_authenticated/settings/email-templates/'
    | '/_authenticated/settings/payments/'
    | '/_authenticated/settings/recording/'
    | '/_authenticated/settings/security/'
    | '/_authenticated/settings/signup-applications/'
    | '/_authenticated/settings/smtp/'
    | '/_authenticated/settings/test-caller-ids/'
    | '/_authenticated/settings/users/'
    | '/_authenticated/customer/campaigns/$id/analytics'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkRouteRoute: typeof ClerkRouteRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRouteWithChildren
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  authSignupRoute: typeof authSignupRouteWithChildren
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  auth2faResetRoute: typeof auth2faResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/sentry-test': {
      id: '/_authenticated/sentry-test'
      path: '/sentry-test'
      fullPath: '/sentry-test'
      preLoaderRoute: typeof AuthenticatedSentryTestRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/balance-transfers': {
      id: '/_authenticated/balance-transfers'
      path: '/balance-transfers'
      fullPath: '/balance-transfers'
      preLoaderRoute: typeof AuthenticatedBalanceTransfersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/signup': {
      id: '/(auth)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof authSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/_authenticated/vendor-panel': {
      id: '/_authenticated/vendor-panel'
      path: '/vendor-panel'
      fullPath: '/vendor-panel'
      preLoaderRoute: typeof AuthenticatedVendorPanelRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reseller': {
      id: '/_authenticated/reseller'
      path: '/reseller'
      fullPath: '/reseller'
      preLoaderRoute: typeof AuthenticatedResellerRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customer': {
      id: '/_authenticated/customer'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof AuthenticatedCustomerRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/buyer-panel': {
      id: '/_authenticated/buyer-panel'
      path: '/buyer-panel'
      fullPath: '/buyer-panel'
      preLoaderRoute: typeof AuthenticatedBuyerPanelRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/audit-logs': {
      id: '/_authenticated/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuthenticatedAuditLogsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/withdrawals/': {
      id: '/_authenticated/withdrawals/'
      path: '/withdrawals'
      fullPath: '/withdrawals/'
      preLoaderRoute: typeof AuthenticatedWithdrawalsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/walkthroughs/': {
      id: '/_authenticated/walkthroughs/'
      path: '/walkthroughs'
      fullPath: '/walkthroughs/'
      preLoaderRoute: typeof AuthenticatedWalkthroughsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/two-factor/': {
      id: '/_authenticated/two-factor/'
      path: '/two-factor'
      fullPath: '/two-factor/'
      preLoaderRoute: typeof AuthenticatedTwoFactorIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tokens/': {
      id: '/_authenticated/tokens/'
      path: '/tokens'
      fullPath: '/tokens/'
      preLoaderRoute: typeof AuthenticatedTokensIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/test-caller-ids/': {
      id: '/_authenticated/test-caller-ids/'
      path: '/test-caller-ids'
      fullPath: '/test-caller-ids/'
      preLoaderRoute: typeof AuthenticatedTestCallerIdsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/teams/': {
      id: '/_authenticated/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof AuthenticatedTeamsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/targets/': {
      id: '/_authenticated/targets/'
      path: '/targets'
      fullPath: '/targets/'
      preLoaderRoute: typeof AuthenticatedTargetsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthenticatedSupportIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/smtp/': {
      id: '/_authenticated/smtp/'
      path: '/smtp'
      fullPath: '/smtp/'
      preLoaderRoute: typeof AuthenticatedSmtpIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/signup-applications/': {
      id: '/_authenticated/signup-applications/'
      path: '/signup-applications'
      fullPath: '/signup-applications/'
      preLoaderRoute: typeof AuthenticatedSignupApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/security/': {
      id: '/_authenticated/security/'
      path: '/security'
      fullPath: '/security/'
      preLoaderRoute: typeof AuthenticatedSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/routing/': {
      id: '/_authenticated/routing/'
      path: '/routing'
      fullPath: '/routing/'
      preLoaderRoute: typeof AuthenticatedRoutingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/resellers/': {
      id: '/_authenticated/resellers/'
      path: '/resellers'
      fullPath: '/resellers/'
      preLoaderRoute: typeof AuthenticatedResellersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reseller/': {
      id: '/_authenticated/reseller/'
      path: '/'
      fullPath: '/reseller/'
      preLoaderRoute: typeof AuthenticatedResellerIndexRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/recording/': {
      id: '/_authenticated/recording/'
      path: '/recording'
      fullPath: '/recording/'
      preLoaderRoute: typeof AuthenticatedRecordingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/permissions/': {
      id: '/_authenticated/permissions/'
      path: '/permissions'
      fullPath: '/permissions/'
      preLoaderRoute: typeof AuthenticatedPermissionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/payments/': {
      id: '/_authenticated/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AuthenticatedPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/memberships/': {
      id: '/_authenticated/memberships/'
      path: '/memberships'
      fullPath: '/memberships/'
      preLoaderRoute: typeof AuthenticatedMembershipsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/maps/': {
      id: '/_authenticated/maps/'
      path: '/maps'
      fullPath: '/maps/'
      preLoaderRoute: typeof AuthenticatedMapsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/lcr/': {
      id: '/_authenticated/lcr/'
      path: '/lcr'
      fullPath: '/lcr/'
      preLoaderRoute: typeof AuthenticatedLcrIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ipqs/': {
      id: '/_authenticated/ipqs/'
      path: '/ipqs'
      fullPath: '/ipqs/'
      preLoaderRoute: typeof AuthenticatedIpqsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/impersonate/': {
      id: '/_authenticated/impersonate/'
      path: '/impersonate'
      fullPath: '/impersonate/'
      preLoaderRoute: typeof AuthenticatedImpersonateIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/email-templates/': {
      id: '/_authenticated/email-templates/'
      path: '/email-templates'
      fullPath: '/email-templates/'
      preLoaderRoute: typeof AuthenticatedEmailTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dids/': {
      id: '/_authenticated/dids/'
      path: '/dids'
      fullPath: '/dids/'
      preLoaderRoute: typeof AuthenticatedDidsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/did-suspensions/': {
      id: '/_authenticated/did-suspensions/'
      path: '/did-suspensions'
      fullPath: '/did-suspensions/'
      preLoaderRoute: typeof AuthenticatedDidSuspensionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/did-providers/': {
      id: '/_authenticated/did-providers/'
      path: '/did-providers'
      fullPath: '/did-providers/'
      preLoaderRoute: typeof AuthenticatedDidProvidersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/did-assignment-report/': {
      id: '/_authenticated/did-assignment-report/'
      path: '/did-assignment-report'
      fullPath: '/did-assignment-report/'
      preLoaderRoute: typeof AuthenticatedDidAssignmentReportIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customer/': {
      id: '/_authenticated/customer/'
      path: '/'
      fullPath: '/customer/'
      preLoaderRoute: typeof AuthenticatedCustomerIndexRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/consolidated-report/': {
      id: '/_authenticated/consolidated-report/'
      path: '/consolidated-report'
      fullPath: '/consolidated-report/'
      preLoaderRoute: typeof AuthenticatedConsolidatedReportIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cdrs/': {
      id: '/_authenticated/cdrs/'
      path: '/cdrs'
      fullPath: '/cdrs/'
      preLoaderRoute: typeof AuthenticatedCdrsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns/': {
      id: '/_authenticated/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthenticatedCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaign-targets/': {
      id: '/_authenticated/campaign-targets/'
      path: '/campaign-targets'
      fullPath: '/campaign-targets/'
      preLoaderRoute: typeof AuthenticatedCampaignTargetsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/call-vendors/': {
      id: '/_authenticated/call-vendors/'
      path: '/call-vendors'
      fullPath: '/call-vendors/'
      preLoaderRoute: typeof AuthenticatedCallVendorsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/buyer-panel/': {
      id: '/_authenticated/buyer-panel/'
      path: '/'
      fullPath: '/buyer-panel/'
      preLoaderRoute: typeof AuthenticatedBuyerPanelIndexRouteImport
      parentRoute: typeof AuthenticatedBuyerPanelRouteRoute
    }
    '/_authenticated/buyer-groups/': {
      id: '/_authenticated/buyer-groups/'
      path: '/buyer-groups'
      fullPath: '/buyer-groups/'
      preLoaderRoute: typeof AuthenticatedBuyerGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/block-caller-ids/': {
      id: '/_authenticated/block-caller-ids/'
      path: '/block-caller-ids'
      fullPath: '/block-caller-ids/'
      preLoaderRoute: typeof AuthenticatedBlockCallerIdsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/billing/': {
      id: '/_authenticated/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AuthenticatedBillingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/activity/': {
      id: '/_authenticated/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof AuthenticatedActivityIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/active-calls/': {
      id: '/_authenticated/active-calls/'
      path: '/active-calls'
      fullPath: '/active-calls/'
      preLoaderRoute: typeof AuthenticatedActiveCallsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth)/signup/': {
      id: '/(auth)/signup/'
      path: '/'
      fullPath: '/signup/'
      preLoaderRoute: typeof authSignupIndexRouteImport
      parentRoute: typeof authSignupRoute
    }
    '/clerk/_authenticated/user-management': {
      id: '/clerk/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/clerk/user-management'
      preLoaderRoute: typeof ClerkAuthenticatedUserManagementRouteImport
      parentRoute: typeof ClerkAuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/vendor-panel/dids': {
      id: '/_authenticated/vendor-panel/dids'
      path: '/dids'
      fullPath: '/vendor-panel/dids'
      preLoaderRoute: typeof AuthenticatedVendorPanelDidsRouteImport
      parentRoute: typeof AuthenticatedVendorPanelRouteRoute
    }
    '/_authenticated/vendor-panel/cdrs': {
      id: '/_authenticated/vendor-panel/cdrs'
      path: '/cdrs'
      fullPath: '/vendor-panel/cdrs'
      preLoaderRoute: typeof AuthenticatedVendorPanelCdrsRouteImport
      parentRoute: typeof AuthenticatedVendorPanelRouteRoute
    }
    '/_authenticated/vendor-panel/active-calls': {
      id: '/_authenticated/vendor-panel/active-calls'
      path: '/active-calls'
      fullPath: '/vendor-panel/active-calls'
      preLoaderRoute: typeof AuthenticatedVendorPanelActiveCallsRouteImport
      parentRoute: typeof AuthenticatedVendorPanelRouteRoute
    }
    '/_authenticated/targets/$id': {
      id: '/_authenticated/targets/$id'
      path: '/targets/$id'
      fullPath: '/targets/$id'
      preLoaderRoute: typeof AuthenticatedTargetsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/resellers/$resellerId': {
      id: '/_authenticated/resellers/$resellerId'
      path: '/resellers/$resellerId'
      fullPath: '/resellers/$resellerId'
      preLoaderRoute: typeof AuthenticatedResellersResellerIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/resellers/$id': {
      id: '/_authenticated/resellers/$id'
      path: '/resellers/$id'
      fullPath: '/resellers/$id'
      preLoaderRoute: typeof AuthenticatedResellersIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reseller/withdrawals': {
      id: '/_authenticated/reseller/withdrawals'
      path: '/withdrawals'
      fullPath: '/reseller/withdrawals'
      preLoaderRoute: typeof AuthenticatedResellerWithdrawalsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/whitelabel': {
      id: '/_authenticated/reseller/whitelabel'
      path: '/whitelabel'
      fullPath: '/reseller/whitelabel'
      preLoaderRoute: typeof AuthenticatedResellerWhitelabelRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/suspended-numbers': {
      id: '/_authenticated/reseller/suspended-numbers'
      path: '/suspended-numbers'
      fullPath: '/reseller/suspended-numbers'
      preLoaderRoute: typeof AuthenticatedResellerSuspendedNumbersRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/smtp': {
      id: '/_authenticated/reseller/smtp'
      path: '/smtp'
      fullPath: '/reseller/smtp'
      preLoaderRoute: typeof AuthenticatedResellerSmtpRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/reports': {
      id: '/_authenticated/reseller/reports'
      path: '/reports'
      fullPath: '/reseller/reports'
      preLoaderRoute: typeof AuthenticatedResellerReportsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/payments': {
      id: '/_authenticated/reseller/payments'
      path: '/payments'
      fullPath: '/reseller/payments'
      preLoaderRoute: typeof AuthenticatedResellerPaymentsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/numbers': {
      id: '/_authenticated/reseller/numbers'
      path: '/numbers'
      fullPath: '/reseller/numbers'
      preLoaderRoute: typeof AuthenticatedResellerNumbersRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/notifications': {
      id: '/_authenticated/reseller/notifications'
      path: '/notifications'
      fullPath: '/reseller/notifications'
      preLoaderRoute: typeof AuthenticatedResellerNotificationsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/invoices': {
      id: '/_authenticated/reseller/invoices'
      path: '/invoices'
      fullPath: '/reseller/invoices'
      preLoaderRoute: typeof AuthenticatedResellerInvoicesRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/impersonate': {
      id: '/_authenticated/reseller/impersonate'
      path: '/impersonate'
      fullPath: '/reseller/impersonate'
      preLoaderRoute: typeof AuthenticatedResellerImpersonateRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/did-transfers': {
      id: '/_authenticated/reseller/did-transfers'
      path: '/did-transfers'
      fullPath: '/reseller/did-transfers'
      preLoaderRoute: typeof AuthenticatedResellerDidTransfersRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/customers': {
      id: '/_authenticated/reseller/customers'
      path: '/customers'
      fullPath: '/reseller/customers'
      preLoaderRoute: typeof AuthenticatedResellerCustomersRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/consolidated-report': {
      id: '/_authenticated/reseller/consolidated-report'
      path: '/consolidated-report'
      fullPath: '/reseller/consolidated-report'
      preLoaderRoute: typeof AuthenticatedResellerConsolidatedReportRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/cdrs': {
      id: '/_authenticated/reseller/cdrs'
      path: '/cdrs'
      fullPath: '/reseller/cdrs'
      preLoaderRoute: typeof AuthenticatedResellerCdrsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/block-caller-ids': {
      id: '/_authenticated/reseller/block-caller-ids'
      path: '/block-caller-ids'
      fullPath: '/reseller/block-caller-ids'
      preLoaderRoute: typeof AuthenticatedResellerBlockCallerIdsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/billing': {
      id: '/_authenticated/reseller/billing'
      path: '/billing'
      fullPath: '/reseller/billing'
      preLoaderRoute: typeof AuthenticatedResellerBillingRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/balance-transfers': {
      id: '/_authenticated/reseller/balance-transfers'
      path: '/balance-transfers'
      fullPath: '/reseller/balance-transfers'
      preLoaderRoute: typeof AuthenticatedResellerBalanceTransfersRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/reseller/activity-logs': {
      id: '/_authenticated/reseller/activity-logs'
      path: '/activity-logs'
      fullPath: '/reseller/activity-logs'
      preLoaderRoute: typeof AuthenticatedResellerActivityLogsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/finance/payments': {
      id: '/_authenticated/finance/payments'
      path: '/finance/payments'
      fullPath: '/finance/payments'
      preLoaderRoute: typeof AuthenticatedFinancePaymentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dids/$id': {
      id: '/_authenticated/dids/$id'
      path: '/dids/$id'
      fullPath: '/dids/$id'
      preLoaderRoute: typeof AuthenticatedDidsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/$id': {
      id: '/_authenticated/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AuthenticatedCustomersIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customer/targets': {
      id: '/_authenticated/customer/targets'
      path: '/targets'
      fullPath: '/customer/targets'
      preLoaderRoute: typeof AuthenticatedCustomerTargetsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/suspended-numbers': {
      id: '/_authenticated/customer/suspended-numbers'
      path: '/suspended-numbers'
      fullPath: '/customer/suspended-numbers'
      preLoaderRoute: typeof AuthenticatedCustomerSuspendedNumbersRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/settings': {
      id: '/_authenticated/customer/settings'
      path: '/settings'
      fullPath: '/customer/settings'
      preLoaderRoute: typeof AuthenticatedCustomerSettingsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/routing-dids': {
      id: '/_authenticated/customer/routing-dids'
      path: '/routing-dids'
      fullPath: '/customer/routing-dids'
      preLoaderRoute: typeof AuthenticatedCustomerRoutingDidsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/reports': {
      id: '/_authenticated/customer/reports'
      path: '/reports'
      fullPath: '/customer/reports'
      preLoaderRoute: typeof AuthenticatedCustomerReportsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/payments': {
      id: '/_authenticated/customer/payments'
      path: '/payments'
      fullPath: '/customer/payments'
      preLoaderRoute: typeof AuthenticatedCustomerPaymentsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/numbers': {
      id: '/_authenticated/customer/numbers'
      path: '/numbers'
      fullPath: '/customer/numbers'
      preLoaderRoute: typeof AuthenticatedCustomerNumbersRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/notifications': {
      id: '/_authenticated/customer/notifications'
      path: '/notifications'
      fullPath: '/customer/notifications'
      preLoaderRoute: typeof AuthenticatedCustomerNotificationsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/invoices': {
      id: '/_authenticated/customer/invoices'
      path: '/invoices'
      fullPath: '/customer/invoices'
      preLoaderRoute: typeof AuthenticatedCustomerInvoicesRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/generate-reports': {
      id: '/_authenticated/customer/generate-reports'
      path: '/generate-reports'
      fullPath: '/customer/generate-reports'
      preLoaderRoute: typeof AuthenticatedCustomerGenerateReportsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/daily-reports': {
      id: '/_authenticated/customer/daily-reports'
      path: '/daily-reports'
      fullPath: '/customer/daily-reports'
      preLoaderRoute: typeof AuthenticatedCustomerDailyReportsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/consolidated-report': {
      id: '/_authenticated/customer/consolidated-report'
      path: '/consolidated-report'
      fullPath: '/customer/consolidated-report'
      preLoaderRoute: typeof AuthenticatedCustomerConsolidatedReportRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/cdrs': {
      id: '/_authenticated/customer/cdrs'
      path: '/cdrs'
      fullPath: '/customer/cdrs'
      preLoaderRoute: typeof AuthenticatedCustomerCdrsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/campaign-targets': {
      id: '/_authenticated/customer/campaign-targets'
      path: '/campaign-targets'
      fullPath: '/customer/campaign-targets'
      preLoaderRoute: typeof AuthenticatedCustomerCampaignTargetsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/call-vendors': {
      id: '/_authenticated/customer/call-vendors'
      path: '/call-vendors'
      fullPath: '/customer/call-vendors'
      preLoaderRoute: typeof AuthenticatedCustomerCallVendorsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/call-blocks': {
      id: '/_authenticated/customer/call-blocks'
      path: '/call-blocks'
      fullPath: '/customer/call-blocks'
      preLoaderRoute: typeof AuthenticatedCustomerCallBlocksRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/buyer-groups': {
      id: '/_authenticated/customer/buyer-groups'
      path: '/buyer-groups'
      fullPath: '/customer/buyer-groups'
      preLoaderRoute: typeof AuthenticatedCustomerBuyerGroupsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/billing': {
      id: '/_authenticated/customer/billing'
      path: '/billing'
      fullPath: '/customer/billing'
      preLoaderRoute: typeof AuthenticatedCustomerBillingRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/api-tokens': {
      id: '/_authenticated/customer/api-tokens'
      path: '/api-tokens'
      fullPath: '/customer/api-tokens'
      preLoaderRoute: typeof AuthenticatedCustomerApiTokensRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/customer/activity-logs': {
      id: '/_authenticated/customer/activity-logs'
      path: '/activity-logs'
      fullPath: '/customer/activity-logs'
      preLoaderRoute: typeof AuthenticatedCustomerActivityLogsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/campaign-targets/$id': {
      id: '/_authenticated/campaign-targets/$id'
      path: '/campaign-targets/$id'
      fullPath: '/campaign-targets/$id'
      preLoaderRoute: typeof AuthenticatedCampaignTargetsIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/buyer-panel/targets': {
      id: '/_authenticated/buyer-panel/targets'
      path: '/targets'
      fullPath: '/buyer-panel/targets'
      preLoaderRoute: typeof AuthenticatedBuyerPanelTargetsRouteImport
      parentRoute: typeof AuthenticatedBuyerPanelRouteRoute
    }
    '/_authenticated/buyer-panel/cdrs': {
      id: '/_authenticated/buyer-panel/cdrs'
      path: '/cdrs'
      fullPath: '/buyer-panel/cdrs'
      preLoaderRoute: typeof AuthenticatedBuyerPanelCdrsRouteImport
      parentRoute: typeof AuthenticatedBuyerPanelRouteRoute
    }
    '/_authenticated/buyer-panel/active-calls': {
      id: '/_authenticated/buyer-panel/active-calls'
      path: '/active-calls'
      fullPath: '/buyer-panel/active-calls'
      preLoaderRoute: typeof AuthenticatedBuyerPanelActiveCallsRouteImport
      parentRoute: typeof AuthenticatedBuyerPanelRouteRoute
    }
    '/(auth)/signup/reseller': {
      id: '/(auth)/signup/reseller'
      path: '/reseller'
      fullPath: '/signup/reseller'
      preLoaderRoute: typeof authSignupResellerRouteImport
      parentRoute: typeof authSignupRoute
    }
    '/(auth)/sign-in/callback': {
      id: '/(auth)/sign-in/callback'
      path: '/callback'
      fullPath: '/sign-in/callback'
      preLoaderRoute: typeof authSignInCallbackRouteImport
      parentRoute: typeof authSignInRoute
    }
    '/(auth)/2fa/reset': {
      id: '/(auth)/2fa/reset'
      path: '/2fa/reset'
      fullPath: '/2fa/reset'
      preLoaderRoute: typeof auth2faResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/customer/campaigns': {
      id: '/_authenticated/customer/campaigns'
      path: '/campaigns'
      fullPath: '/customer/campaigns'
      preLoaderRoute: typeof AuthenticatedCustomerCampaignsRouteRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/settings/users/': {
      id: '/_authenticated/settings/users/'
      path: '/users'
      fullPath: '/settings/users/'
      preLoaderRoute: typeof AuthenticatedSettingsUsersIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/test-caller-ids/': {
      id: '/_authenticated/settings/test-caller-ids/'
      path: '/test-caller-ids'
      fullPath: '/settings/test-caller-ids/'
      preLoaderRoute: typeof AuthenticatedSettingsTestCallerIdsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/smtp/': {
      id: '/_authenticated/settings/smtp/'
      path: '/smtp'
      fullPath: '/settings/smtp/'
      preLoaderRoute: typeof AuthenticatedSettingsSmtpIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/signup-applications/': {
      id: '/_authenticated/settings/signup-applications/'
      path: '/signup-applications'
      fullPath: '/settings/signup-applications/'
      preLoaderRoute: typeof AuthenticatedSettingsSignupApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/security/': {
      id: '/_authenticated/settings/security/'
      path: '/security'
      fullPath: '/settings/security/'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/recording/': {
      id: '/_authenticated/settings/recording/'
      path: '/recording'
      fullPath: '/settings/recording/'
      preLoaderRoute: typeof AuthenticatedSettingsRecordingIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/payments/': {
      id: '/_authenticated/settings/payments/'
      path: '/payments'
      fullPath: '/settings/payments/'
      preLoaderRoute: typeof AuthenticatedSettingsPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/email-templates/': {
      id: '/_authenticated/settings/email-templates/'
      path: '/email-templates'
      fullPath: '/settings/email-templates/'
      preLoaderRoute: typeof AuthenticatedSettingsEmailTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/freeswitch/trunks/': {
      id: '/_authenticated/freeswitch/trunks/'
      path: '/freeswitch/trunks'
      fullPath: '/freeswitch/trunks/'
      preLoaderRoute: typeof AuthenticatedFreeswitchTrunksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/freeswitch/servers/': {
      id: '/_authenticated/freeswitch/servers/'
      path: '/freeswitch/servers'
      fullPath: '/freeswitch/servers/'
      preLoaderRoute: typeof AuthenticatedFreeswitchServersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/freeswitch/profiles/': {
      id: '/_authenticated/freeswitch/profiles/'
      path: '/freeswitch/profiles'
      fullPath: '/freeswitch/profiles/'
      preLoaderRoute: typeof AuthenticatedFreeswitchProfilesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/freeswitch/gateways/': {
      id: '/_authenticated/freeswitch/gateways/'
      path: '/freeswitch/gateways'
      fullPath: '/freeswitch/gateways/'
      preLoaderRoute: typeof AuthenticatedFreeswitchGatewaysIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/freeswitch/apply/': {
      id: '/_authenticated/freeswitch/apply/'
      path: '/freeswitch/apply'
      fullPath: '/freeswitch/apply/'
      preLoaderRoute: typeof AuthenticatedFreeswitchApplyIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dids/import/': {
      id: '/_authenticated/dids/import/'
      path: '/dids/import'
      fullPath: '/dids/import/'
      preLoaderRoute: typeof AuthenticatedDidsImportIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customer/campaigns/': {
      id: '/_authenticated/customer/campaigns/'
      path: '/'
      fullPath: '/customer/campaigns/'
      preLoaderRoute: typeof AuthenticatedCustomerCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedCustomerCampaignsRouteRoute
    }
    '/_authenticated/cdrs/unauthorized/': {
      id: '/_authenticated/cdrs/unauthorized/'
      path: '/cdrs/unauthorized'
      fullPath: '/cdrs/unauthorized/'
      preLoaderRoute: typeof AuthenticatedCdrsUnauthorizedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/campaigns/$id/': {
      id: '/_authenticated/campaigns/$id/'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id/'
      preLoaderRoute: typeof AuthenticatedCampaignsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reseller/finance/payments': {
      id: '/_authenticated/reseller/finance/payments'
      path: '/finance/payments'
      fullPath: '/reseller/finance/payments'
      preLoaderRoute: typeof AuthenticatedResellerFinancePaymentsRouteImport
      parentRoute: typeof AuthenticatedResellerRouteRoute
    }
    '/_authenticated/customer/finance/payments': {
      id: '/_authenticated/customer/finance/payments'
      path: '/finance/payments'
      fullPath: '/customer/finance/payments'
      preLoaderRoute: typeof AuthenticatedCustomerFinancePaymentsRouteImport
      parentRoute: typeof AuthenticatedCustomerRouteRoute
    }
    '/_authenticated/campaigns/$id/analytics': {
      id: '/_authenticated/campaigns/$id/analytics'
      path: '/campaigns/$id/analytics'
      fullPath: '/campaigns/$id/analytics'
      preLoaderRoute: typeof AuthenticatedCampaignsIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customer/campaigns/$id/analytics': {
      id: '/_authenticated/customer/campaigns/$id/analytics'
      path: '/$id/analytics'
      fullPath: '/customer/campaigns/$id/analytics'
      preLoaderRoute: typeof AuthenticatedCustomerCampaignsIdAnalyticsRouteImport
      parentRoute: typeof AuthenticatedCustomerCampaignsRouteRoute
    }
  }
}

interface AuthenticatedBuyerPanelRouteRouteChildren {
  AuthenticatedBuyerPanelActiveCallsRoute: typeof AuthenticatedBuyerPanelActiveCallsRoute
  AuthenticatedBuyerPanelCdrsRoute: typeof AuthenticatedBuyerPanelCdrsRoute
  AuthenticatedBuyerPanelTargetsRoute: typeof AuthenticatedBuyerPanelTargetsRoute
  AuthenticatedBuyerPanelIndexRoute: typeof AuthenticatedBuyerPanelIndexRoute
}

const AuthenticatedBuyerPanelRouteRouteChildren: AuthenticatedBuyerPanelRouteRouteChildren =
  {
    AuthenticatedBuyerPanelActiveCallsRoute:
      AuthenticatedBuyerPanelActiveCallsRoute,
    AuthenticatedBuyerPanelCdrsRoute: AuthenticatedBuyerPanelCdrsRoute,
    AuthenticatedBuyerPanelTargetsRoute: AuthenticatedBuyerPanelTargetsRoute,
    AuthenticatedBuyerPanelIndexRoute: AuthenticatedBuyerPanelIndexRoute,
  }

const AuthenticatedBuyerPanelRouteRouteWithChildren =
  AuthenticatedBuyerPanelRouteRoute._addFileChildren(
    AuthenticatedBuyerPanelRouteRouteChildren,
  )

interface AuthenticatedCustomerCampaignsRouteRouteChildren {
  AuthenticatedCustomerCampaignsIndexRoute: typeof AuthenticatedCustomerCampaignsIndexRoute
  AuthenticatedCustomerCampaignsIdAnalyticsRoute: typeof AuthenticatedCustomerCampaignsIdAnalyticsRoute
}

const AuthenticatedCustomerCampaignsRouteRouteChildren: AuthenticatedCustomerCampaignsRouteRouteChildren =
  {
    AuthenticatedCustomerCampaignsIndexRoute:
      AuthenticatedCustomerCampaignsIndexRoute,
    AuthenticatedCustomerCampaignsIdAnalyticsRoute:
      AuthenticatedCustomerCampaignsIdAnalyticsRoute,
  }

const AuthenticatedCustomerCampaignsRouteRouteWithChildren =
  AuthenticatedCustomerCampaignsRouteRoute._addFileChildren(
    AuthenticatedCustomerCampaignsRouteRouteChildren,
  )

interface AuthenticatedCustomerRouteRouteChildren {
  AuthenticatedCustomerCampaignsRouteRoute: typeof AuthenticatedCustomerCampaignsRouteRouteWithChildren
  AuthenticatedCustomerActivityLogsRoute: typeof AuthenticatedCustomerActivityLogsRoute
  AuthenticatedCustomerApiTokensRoute: typeof AuthenticatedCustomerApiTokensRoute
  AuthenticatedCustomerBillingRoute: typeof AuthenticatedCustomerBillingRoute
  AuthenticatedCustomerBuyerGroupsRoute: typeof AuthenticatedCustomerBuyerGroupsRoute
  AuthenticatedCustomerCallBlocksRoute: typeof AuthenticatedCustomerCallBlocksRoute
  AuthenticatedCustomerCallVendorsRoute: typeof AuthenticatedCustomerCallVendorsRoute
  AuthenticatedCustomerCampaignTargetsRoute: typeof AuthenticatedCustomerCampaignTargetsRoute
  AuthenticatedCustomerCdrsRoute: typeof AuthenticatedCustomerCdrsRoute
  AuthenticatedCustomerConsolidatedReportRoute: typeof AuthenticatedCustomerConsolidatedReportRoute
  AuthenticatedCustomerDailyReportsRoute: typeof AuthenticatedCustomerDailyReportsRoute
  AuthenticatedCustomerGenerateReportsRoute: typeof AuthenticatedCustomerGenerateReportsRoute
  AuthenticatedCustomerInvoicesRoute: typeof AuthenticatedCustomerInvoicesRoute
  AuthenticatedCustomerNotificationsRoute: typeof AuthenticatedCustomerNotificationsRoute
  AuthenticatedCustomerNumbersRoute: typeof AuthenticatedCustomerNumbersRoute
  AuthenticatedCustomerPaymentsRoute: typeof AuthenticatedCustomerPaymentsRoute
  AuthenticatedCustomerReportsRoute: typeof AuthenticatedCustomerReportsRoute
  AuthenticatedCustomerRoutingDidsRoute: typeof AuthenticatedCustomerRoutingDidsRoute
  AuthenticatedCustomerSettingsRoute: typeof AuthenticatedCustomerSettingsRoute
  AuthenticatedCustomerSuspendedNumbersRoute: typeof AuthenticatedCustomerSuspendedNumbersRoute
  AuthenticatedCustomerTargetsRoute: typeof AuthenticatedCustomerTargetsRoute
  AuthenticatedCustomerIndexRoute: typeof AuthenticatedCustomerIndexRoute
  AuthenticatedCustomerFinancePaymentsRoute: typeof AuthenticatedCustomerFinancePaymentsRoute
}

const AuthenticatedCustomerRouteRouteChildren: AuthenticatedCustomerRouteRouteChildren =
  {
    AuthenticatedCustomerCampaignsRouteRoute:
      AuthenticatedCustomerCampaignsRouteRouteWithChildren,
    AuthenticatedCustomerActivityLogsRoute:
      AuthenticatedCustomerActivityLogsRoute,
    AuthenticatedCustomerApiTokensRoute: AuthenticatedCustomerApiTokensRoute,
    AuthenticatedCustomerBillingRoute: AuthenticatedCustomerBillingRoute,
    AuthenticatedCustomerBuyerGroupsRoute:
      AuthenticatedCustomerBuyerGroupsRoute,
    AuthenticatedCustomerCallBlocksRoute: AuthenticatedCustomerCallBlocksRoute,
    AuthenticatedCustomerCallVendorsRoute:
      AuthenticatedCustomerCallVendorsRoute,
    AuthenticatedCustomerCampaignTargetsRoute:
      AuthenticatedCustomerCampaignTargetsRoute,
    AuthenticatedCustomerCdrsRoute: AuthenticatedCustomerCdrsRoute,
    AuthenticatedCustomerConsolidatedReportRoute:
      AuthenticatedCustomerConsolidatedReportRoute,
    AuthenticatedCustomerDailyReportsRoute:
      AuthenticatedCustomerDailyReportsRoute,
    AuthenticatedCustomerGenerateReportsRoute:
      AuthenticatedCustomerGenerateReportsRoute,
    AuthenticatedCustomerInvoicesRoute: AuthenticatedCustomerInvoicesRoute,
    AuthenticatedCustomerNotificationsRoute:
      AuthenticatedCustomerNotificationsRoute,
    AuthenticatedCustomerNumbersRoute: AuthenticatedCustomerNumbersRoute,
    AuthenticatedCustomerPaymentsRoute: AuthenticatedCustomerPaymentsRoute,
    AuthenticatedCustomerReportsRoute: AuthenticatedCustomerReportsRoute,
    AuthenticatedCustomerRoutingDidsRoute:
      AuthenticatedCustomerRoutingDidsRoute,
    AuthenticatedCustomerSettingsRoute: AuthenticatedCustomerSettingsRoute,
    AuthenticatedCustomerSuspendedNumbersRoute:
      AuthenticatedCustomerSuspendedNumbersRoute,
    AuthenticatedCustomerTargetsRoute: AuthenticatedCustomerTargetsRoute,
    AuthenticatedCustomerIndexRoute: AuthenticatedCustomerIndexRoute,
    AuthenticatedCustomerFinancePaymentsRoute:
      AuthenticatedCustomerFinancePaymentsRoute,
  }

const AuthenticatedCustomerRouteRouteWithChildren =
  AuthenticatedCustomerRouteRoute._addFileChildren(
    AuthenticatedCustomerRouteRouteChildren,
  )

interface AuthenticatedResellerRouteRouteChildren {
  AuthenticatedResellerActivityLogsRoute: typeof AuthenticatedResellerActivityLogsRoute
  AuthenticatedResellerBalanceTransfersRoute: typeof AuthenticatedResellerBalanceTransfersRoute
  AuthenticatedResellerBillingRoute: typeof AuthenticatedResellerBillingRoute
  AuthenticatedResellerBlockCallerIdsRoute: typeof AuthenticatedResellerBlockCallerIdsRoute
  AuthenticatedResellerCdrsRoute: typeof AuthenticatedResellerCdrsRoute
  AuthenticatedResellerConsolidatedReportRoute: typeof AuthenticatedResellerConsolidatedReportRoute
  AuthenticatedResellerCustomersRoute: typeof AuthenticatedResellerCustomersRoute
  AuthenticatedResellerDidTransfersRoute: typeof AuthenticatedResellerDidTransfersRoute
  AuthenticatedResellerImpersonateRoute: typeof AuthenticatedResellerImpersonateRoute
  AuthenticatedResellerInvoicesRoute: typeof AuthenticatedResellerInvoicesRoute
  AuthenticatedResellerNotificationsRoute: typeof AuthenticatedResellerNotificationsRoute
  AuthenticatedResellerNumbersRoute: typeof AuthenticatedResellerNumbersRoute
  AuthenticatedResellerPaymentsRoute: typeof AuthenticatedResellerPaymentsRoute
  AuthenticatedResellerReportsRoute: typeof AuthenticatedResellerReportsRoute
  AuthenticatedResellerSmtpRoute: typeof AuthenticatedResellerSmtpRoute
  AuthenticatedResellerSuspendedNumbersRoute: typeof AuthenticatedResellerSuspendedNumbersRoute
  AuthenticatedResellerWhitelabelRoute: typeof AuthenticatedResellerWhitelabelRoute
  AuthenticatedResellerWithdrawalsRoute: typeof AuthenticatedResellerWithdrawalsRoute
  AuthenticatedResellerIndexRoute: typeof AuthenticatedResellerIndexRoute
  AuthenticatedResellerFinancePaymentsRoute: typeof AuthenticatedResellerFinancePaymentsRoute
}

const AuthenticatedResellerRouteRouteChildren: AuthenticatedResellerRouteRouteChildren =
  {
    AuthenticatedResellerActivityLogsRoute:
      AuthenticatedResellerActivityLogsRoute,
    AuthenticatedResellerBalanceTransfersRoute:
      AuthenticatedResellerBalanceTransfersRoute,
    AuthenticatedResellerBillingRoute: AuthenticatedResellerBillingRoute,
    AuthenticatedResellerBlockCallerIdsRoute:
      AuthenticatedResellerBlockCallerIdsRoute,
    AuthenticatedResellerCdrsRoute: AuthenticatedResellerCdrsRoute,
    AuthenticatedResellerConsolidatedReportRoute:
      AuthenticatedResellerConsolidatedReportRoute,
    AuthenticatedResellerCustomersRoute: AuthenticatedResellerCustomersRoute,
    AuthenticatedResellerDidTransfersRoute:
      AuthenticatedResellerDidTransfersRoute,
    AuthenticatedResellerImpersonateRoute:
      AuthenticatedResellerImpersonateRoute,
    AuthenticatedResellerInvoicesRoute: AuthenticatedResellerInvoicesRoute,
    AuthenticatedResellerNotificationsRoute:
      AuthenticatedResellerNotificationsRoute,
    AuthenticatedResellerNumbersRoute: AuthenticatedResellerNumbersRoute,
    AuthenticatedResellerPaymentsRoute: AuthenticatedResellerPaymentsRoute,
    AuthenticatedResellerReportsRoute: AuthenticatedResellerReportsRoute,
    AuthenticatedResellerSmtpRoute: AuthenticatedResellerSmtpRoute,
    AuthenticatedResellerSuspendedNumbersRoute:
      AuthenticatedResellerSuspendedNumbersRoute,
    AuthenticatedResellerWhitelabelRoute: AuthenticatedResellerWhitelabelRoute,
    AuthenticatedResellerWithdrawalsRoute:
      AuthenticatedResellerWithdrawalsRoute,
    AuthenticatedResellerIndexRoute: AuthenticatedResellerIndexRoute,
    AuthenticatedResellerFinancePaymentsRoute:
      AuthenticatedResellerFinancePaymentsRoute,
  }

const AuthenticatedResellerRouteRouteWithChildren =
  AuthenticatedResellerRouteRoute._addFileChildren(
    AuthenticatedResellerRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsEmailTemplatesIndexRoute: typeof AuthenticatedSettingsEmailTemplatesIndexRoute
  AuthenticatedSettingsPaymentsIndexRoute: typeof AuthenticatedSettingsPaymentsIndexRoute
  AuthenticatedSettingsRecordingIndexRoute: typeof AuthenticatedSettingsRecordingIndexRoute
  AuthenticatedSettingsSecurityIndexRoute: typeof AuthenticatedSettingsSecurityIndexRoute
  AuthenticatedSettingsSignupApplicationsIndexRoute: typeof AuthenticatedSettingsSignupApplicationsIndexRoute
  AuthenticatedSettingsSmtpIndexRoute: typeof AuthenticatedSettingsSmtpIndexRoute
  AuthenticatedSettingsTestCallerIdsIndexRoute: typeof AuthenticatedSettingsTestCallerIdsIndexRoute
  AuthenticatedSettingsUsersIndexRoute: typeof AuthenticatedSettingsUsersIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
    AuthenticatedSettingsEmailTemplatesIndexRoute:
      AuthenticatedSettingsEmailTemplatesIndexRoute,
    AuthenticatedSettingsPaymentsIndexRoute:
      AuthenticatedSettingsPaymentsIndexRoute,
    AuthenticatedSettingsRecordingIndexRoute:
      AuthenticatedSettingsRecordingIndexRoute,
    AuthenticatedSettingsSecurityIndexRoute:
      AuthenticatedSettingsSecurityIndexRoute,
    AuthenticatedSettingsSignupApplicationsIndexRoute:
      AuthenticatedSettingsSignupApplicationsIndexRoute,
    AuthenticatedSettingsSmtpIndexRoute: AuthenticatedSettingsSmtpIndexRoute,
    AuthenticatedSettingsTestCallerIdsIndexRoute:
      AuthenticatedSettingsTestCallerIdsIndexRoute,
    AuthenticatedSettingsUsersIndexRoute: AuthenticatedSettingsUsersIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedVendorPanelRouteRouteChildren {
  AuthenticatedVendorPanelActiveCallsRoute: typeof AuthenticatedVendorPanelActiveCallsRoute
  AuthenticatedVendorPanelCdrsRoute: typeof AuthenticatedVendorPanelCdrsRoute
  AuthenticatedVendorPanelDidsRoute: typeof AuthenticatedVendorPanelDidsRoute
}

const AuthenticatedVendorPanelRouteRouteChildren: AuthenticatedVendorPanelRouteRouteChildren =
  {
    AuthenticatedVendorPanelActiveCallsRoute:
      AuthenticatedVendorPanelActiveCallsRoute,
    AuthenticatedVendorPanelCdrsRoute: AuthenticatedVendorPanelCdrsRoute,
    AuthenticatedVendorPanelDidsRoute: AuthenticatedVendorPanelDidsRoute,
  }

const AuthenticatedVendorPanelRouteRouteWithChildren =
  AuthenticatedVendorPanelRouteRoute._addFileChildren(
    AuthenticatedVendorPanelRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAuditLogsRouteRoute: typeof AuthenticatedAuditLogsRouteRoute
  AuthenticatedBuyerPanelRouteRoute: typeof AuthenticatedBuyerPanelRouteRouteWithChildren
  AuthenticatedCustomerRouteRoute: typeof AuthenticatedCustomerRouteRouteWithChildren
  AuthenticatedResellerRouteRoute: typeof AuthenticatedResellerRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedVendorPanelRouteRoute: typeof AuthenticatedVendorPanelRouteRouteWithChildren
  AuthenticatedBalanceTransfersRoute: typeof AuthenticatedBalanceTransfersRoute
  AuthenticatedSentryTestRoute: typeof AuthenticatedSentryTestRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCampaignTargetsIdRoute: typeof AuthenticatedCampaignTargetsIdRoute
  AuthenticatedCustomersIdRoute: typeof AuthenticatedCustomersIdRoute
  AuthenticatedDidsIdRoute: typeof AuthenticatedDidsIdRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedFinancePaymentsRoute: typeof AuthenticatedFinancePaymentsRoute
  AuthenticatedResellersIdRoute: typeof AuthenticatedResellersIdRoute
  AuthenticatedResellersResellerIdRoute: typeof AuthenticatedResellersResellerIdRoute
  AuthenticatedTargetsIdRoute: typeof AuthenticatedTargetsIdRoute
  AuthenticatedActiveCallsIndexRoute: typeof AuthenticatedActiveCallsIndexRoute
  AuthenticatedActivityIndexRoute: typeof AuthenticatedActivityIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedBillingIndexRoute: typeof AuthenticatedBillingIndexRoute
  AuthenticatedBlockCallerIdsIndexRoute: typeof AuthenticatedBlockCallerIdsIndexRoute
  AuthenticatedBuyerGroupsIndexRoute: typeof AuthenticatedBuyerGroupsIndexRoute
  AuthenticatedCallVendorsIndexRoute: typeof AuthenticatedCallVendorsIndexRoute
  AuthenticatedCampaignTargetsIndexRoute: typeof AuthenticatedCampaignTargetsIndexRoute
  AuthenticatedCampaignsIndexRoute: typeof AuthenticatedCampaignsIndexRoute
  AuthenticatedCdrsIndexRoute: typeof AuthenticatedCdrsIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedConsolidatedReportIndexRoute: typeof AuthenticatedConsolidatedReportIndexRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedDidAssignmentReportIndexRoute: typeof AuthenticatedDidAssignmentReportIndexRoute
  AuthenticatedDidProvidersIndexRoute: typeof AuthenticatedDidProvidersIndexRoute
  AuthenticatedDidSuspensionsIndexRoute: typeof AuthenticatedDidSuspensionsIndexRoute
  AuthenticatedDidsIndexRoute: typeof AuthenticatedDidsIndexRoute
  AuthenticatedEmailTemplatesIndexRoute: typeof AuthenticatedEmailTemplatesIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedImpersonateIndexRoute: typeof AuthenticatedImpersonateIndexRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedIpqsIndexRoute: typeof AuthenticatedIpqsIndexRoute
  AuthenticatedLcrIndexRoute: typeof AuthenticatedLcrIndexRoute
  AuthenticatedMapsIndexRoute: typeof AuthenticatedMapsIndexRoute
  AuthenticatedMembershipsIndexRoute: typeof AuthenticatedMembershipsIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedPaymentsIndexRoute: typeof AuthenticatedPaymentsIndexRoute
  AuthenticatedPermissionsIndexRoute: typeof AuthenticatedPermissionsIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedRecordingIndexRoute: typeof AuthenticatedRecordingIndexRoute
  AuthenticatedResellersIndexRoute: typeof AuthenticatedResellersIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedRoutingIndexRoute: typeof AuthenticatedRoutingIndexRoute
  AuthenticatedSecurityIndexRoute: typeof AuthenticatedSecurityIndexRoute
  AuthenticatedSignupApplicationsIndexRoute: typeof AuthenticatedSignupApplicationsIndexRoute
  AuthenticatedSmtpIndexRoute: typeof AuthenticatedSmtpIndexRoute
  AuthenticatedSupportIndexRoute: typeof AuthenticatedSupportIndexRoute
  AuthenticatedTargetsIndexRoute: typeof AuthenticatedTargetsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTeamsIndexRoute: typeof AuthenticatedTeamsIndexRoute
  AuthenticatedTestCallerIdsIndexRoute: typeof AuthenticatedTestCallerIdsIndexRoute
  AuthenticatedTokensIndexRoute: typeof AuthenticatedTokensIndexRoute
  AuthenticatedTwoFactorIndexRoute: typeof AuthenticatedTwoFactorIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedWalkthroughsIndexRoute: typeof AuthenticatedWalkthroughsIndexRoute
  AuthenticatedWithdrawalsIndexRoute: typeof AuthenticatedWithdrawalsIndexRoute
  AuthenticatedCampaignsIdAnalyticsRoute: typeof AuthenticatedCampaignsIdAnalyticsRoute
  AuthenticatedCampaignsIdIndexRoute: typeof AuthenticatedCampaignsIdIndexRoute
  AuthenticatedCdrsUnauthorizedIndexRoute: typeof AuthenticatedCdrsUnauthorizedIndexRoute
  AuthenticatedDidsImportIndexRoute: typeof AuthenticatedDidsImportIndexRoute
  AuthenticatedFreeswitchApplyIndexRoute: typeof AuthenticatedFreeswitchApplyIndexRoute
  AuthenticatedFreeswitchGatewaysIndexRoute: typeof AuthenticatedFreeswitchGatewaysIndexRoute
  AuthenticatedFreeswitchProfilesIndexRoute: typeof AuthenticatedFreeswitchProfilesIndexRoute
  AuthenticatedFreeswitchServersIndexRoute: typeof AuthenticatedFreeswitchServersIndexRoute
  AuthenticatedFreeswitchTrunksIndexRoute: typeof AuthenticatedFreeswitchTrunksIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAuditLogsRouteRoute: AuthenticatedAuditLogsRouteRoute,
  AuthenticatedBuyerPanelRouteRoute:
    AuthenticatedBuyerPanelRouteRouteWithChildren,
  AuthenticatedCustomerRouteRoute: AuthenticatedCustomerRouteRouteWithChildren,
  AuthenticatedResellerRouteRoute: AuthenticatedResellerRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedVendorPanelRouteRoute:
    AuthenticatedVendorPanelRouteRouteWithChildren,
  AuthenticatedBalanceTransfersRoute: AuthenticatedBalanceTransfersRoute,
  AuthenticatedSentryTestRoute: AuthenticatedSentryTestRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCampaignTargetsIdRoute: AuthenticatedCampaignTargetsIdRoute,
  AuthenticatedCustomersIdRoute: AuthenticatedCustomersIdRoute,
  AuthenticatedDidsIdRoute: AuthenticatedDidsIdRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedFinancePaymentsRoute: AuthenticatedFinancePaymentsRoute,
  AuthenticatedResellersIdRoute: AuthenticatedResellersIdRoute,
  AuthenticatedResellersResellerIdRoute: AuthenticatedResellersResellerIdRoute,
  AuthenticatedTargetsIdRoute: AuthenticatedTargetsIdRoute,
  AuthenticatedActiveCallsIndexRoute: AuthenticatedActiveCallsIndexRoute,
  AuthenticatedActivityIndexRoute: AuthenticatedActivityIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedBillingIndexRoute: AuthenticatedBillingIndexRoute,
  AuthenticatedBlockCallerIdsIndexRoute: AuthenticatedBlockCallerIdsIndexRoute,
  AuthenticatedBuyerGroupsIndexRoute: AuthenticatedBuyerGroupsIndexRoute,
  AuthenticatedCallVendorsIndexRoute: AuthenticatedCallVendorsIndexRoute,
  AuthenticatedCampaignTargetsIndexRoute:
    AuthenticatedCampaignTargetsIndexRoute,
  AuthenticatedCampaignsIndexRoute: AuthenticatedCampaignsIndexRoute,
  AuthenticatedCdrsIndexRoute: AuthenticatedCdrsIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedConsolidatedReportIndexRoute:
    AuthenticatedConsolidatedReportIndexRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedDidAssignmentReportIndexRoute:
    AuthenticatedDidAssignmentReportIndexRoute,
  AuthenticatedDidProvidersIndexRoute: AuthenticatedDidProvidersIndexRoute,
  AuthenticatedDidSuspensionsIndexRoute: AuthenticatedDidSuspensionsIndexRoute,
  AuthenticatedDidsIndexRoute: AuthenticatedDidsIndexRoute,
  AuthenticatedEmailTemplatesIndexRoute: AuthenticatedEmailTemplatesIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedImpersonateIndexRoute: AuthenticatedImpersonateIndexRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedIpqsIndexRoute: AuthenticatedIpqsIndexRoute,
  AuthenticatedLcrIndexRoute: AuthenticatedLcrIndexRoute,
  AuthenticatedMapsIndexRoute: AuthenticatedMapsIndexRoute,
  AuthenticatedMembershipsIndexRoute: AuthenticatedMembershipsIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedPaymentsIndexRoute: AuthenticatedPaymentsIndexRoute,
  AuthenticatedPermissionsIndexRoute: AuthenticatedPermissionsIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedRecordingIndexRoute: AuthenticatedRecordingIndexRoute,
  AuthenticatedResellersIndexRoute: AuthenticatedResellersIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedRoutingIndexRoute: AuthenticatedRoutingIndexRoute,
  AuthenticatedSecurityIndexRoute: AuthenticatedSecurityIndexRoute,
  AuthenticatedSignupApplicationsIndexRoute:
    AuthenticatedSignupApplicationsIndexRoute,
  AuthenticatedSmtpIndexRoute: AuthenticatedSmtpIndexRoute,
  AuthenticatedSupportIndexRoute: AuthenticatedSupportIndexRoute,
  AuthenticatedTargetsIndexRoute: AuthenticatedTargetsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTeamsIndexRoute: AuthenticatedTeamsIndexRoute,
  AuthenticatedTestCallerIdsIndexRoute: AuthenticatedTestCallerIdsIndexRoute,
  AuthenticatedTokensIndexRoute: AuthenticatedTokensIndexRoute,
  AuthenticatedTwoFactorIndexRoute: AuthenticatedTwoFactorIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedWalkthroughsIndexRoute: AuthenticatedWalkthroughsIndexRoute,
  AuthenticatedWithdrawalsIndexRoute: AuthenticatedWithdrawalsIndexRoute,
  AuthenticatedCampaignsIdAnalyticsRoute:
    AuthenticatedCampaignsIdAnalyticsRoute,
  AuthenticatedCampaignsIdIndexRoute: AuthenticatedCampaignsIdIndexRoute,
  AuthenticatedCdrsUnauthorizedIndexRoute:
    AuthenticatedCdrsUnauthorizedIndexRoute,
  AuthenticatedDidsImportIndexRoute: AuthenticatedDidsImportIndexRoute,
  AuthenticatedFreeswitchApplyIndexRoute:
    AuthenticatedFreeswitchApplyIndexRoute,
  AuthenticatedFreeswitchGatewaysIndexRoute:
    AuthenticatedFreeswitchGatewaysIndexRoute,
  AuthenticatedFreeswitchProfilesIndexRoute:
    AuthenticatedFreeswitchProfilesIndexRoute,
  AuthenticatedFreeswitchServersIndexRoute:
    AuthenticatedFreeswitchServersIndexRoute,
  AuthenticatedFreeswitchTrunksIndexRoute:
    AuthenticatedFreeswitchTrunksIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkAuthenticatedRouteRouteChildren {
  ClerkAuthenticatedUserManagementRoute: typeof ClerkAuthenticatedUserManagementRoute
}

const ClerkAuthenticatedRouteRouteChildren: ClerkAuthenticatedRouteRouteChildren =
  {
    ClerkAuthenticatedUserManagementRoute:
      ClerkAuthenticatedUserManagementRoute,
  }

const ClerkAuthenticatedRouteRouteWithChildren =
  ClerkAuthenticatedRouteRoute._addFileChildren(
    ClerkAuthenticatedRouteRouteChildren,
  )

interface ClerkRouteRouteChildren {
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRouteWithChildren
}

const ClerkRouteRouteChildren: ClerkRouteRouteChildren = {
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRouteWithChildren,
}

const ClerkRouteRouteWithChildren = ClerkRouteRoute._addFileChildren(
  ClerkRouteRouteChildren,
)

interface authSignInRouteChildren {
  authSignInCallbackRoute: typeof authSignInCallbackRoute
}

const authSignInRouteChildren: authSignInRouteChildren = {
  authSignInCallbackRoute: authSignInCallbackRoute,
}

const authSignInRouteWithChildren = authSignInRoute._addFileChildren(
  authSignInRouteChildren,
)

interface authSignupRouteChildren {
  authSignupResellerRoute: typeof authSignupResellerRoute
  authSignupIndexRoute: typeof authSignupIndexRoute
}

const authSignupRouteChildren: authSignupRouteChildren = {
  authSignupResellerRoute: authSignupResellerRoute,
  authSignupIndexRoute: authSignupIndexRoute,
}

const authSignupRouteWithChildren = authSignupRoute._addFileChildren(
  authSignupRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkRouteRoute: ClerkRouteRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRouteWithChildren,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  authSignupRoute: authSignupRouteWithChildren,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  auth2faResetRoute: auth2faResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
